<template>
  <div class="miniBTC">
    
    <Headers :windowWidth="windowWidth" />
    
    <!-- Carbon Footprint -->
    <div class="mini_bg" v-if="index == 2">
      <div class="continer_width top_box">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="grid-content bg-purple">
              <div class="bg_title" style="font-size:32px">
                <span>{{ $t("carbonIndex.bg_title_More")}}</span>
                <!-- <div v-if="login.groupId">
                  <span v-if="login.groupId == 1">{{ $t("carbonIndex.FriendShipCountryMena") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 2">{{ $t("carbonIndex.FriendShipCountryAsean") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 3"><span>China-Singapore({{login.country}})</span> <span style="font-weight:600">Carbon Neutrality</span> Connect</span>
                </div>
                <div v-else>
                  <span v-if="login.country == 'Pahang'">{{login.country ? login.country + ' State ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                  <span v-else>{{login.country ? login.country + ' National ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                </div> -->

              </div>
              <div class="Specs">
                A Digital Registry Powered by MVGX Technology
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div v-if="radiofoot == '1'">
              <div class="steps">
                <el-steps :active="stepsCarbon" align-center finish-status="success">
                    <el-step description="Project Initiation"></el-step>
                    <el-step description="Emission Quantification"></el-step>
                    <el-step description="Report Generation"></el-step>
                </el-steps>
              </div>
            </div>
            <div v-if="radiofoot == '2'">
              <div class="steps">
                <el-steps :active="stepsCarbon" align-center finish-status="success">
                    <el-step description="Project Initiation"></el-step>
                    <el-step description="Emission Quantification"></el-step>
                    <el-step description="Report Generation & Submission"></el-step>
                    <el-step description="Verification by Certification Agency"></el-step>
                    <el-step description="Certificate Issuance"></el-step>
                    <el-step description="NFT creation"></el-step>
                </el-steps>
              </div>
            </div>
            <div v-if="radiofoot == ''">
              <div class="cf_title">{{login.country ? login.country + ' National ' : 'MetaVerse Green'}} Carbon Footprint Tool</div>
              <div class="cf_h3">A tool for organizations to </div>
              <div class="cf_h4">· Quantify their carbon footprint; </div>
              <div class="cf_h4">· Report their carbon footprint; </div>
              <div class="cf_h4">· Be certified for their carbon footprint based on ISO standards. </div>
            </div>
          </el-col>
        </el-row>
        <div class="grid-content bg-purple ab_box">
          <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu_box" />
        </div>
      </div>
    </div>

    <!-- Carbon Neutrality -->
    <div class="mini_bg" v-else-if="index == 3">
      <div class="continer_width top_box">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="grid-content bg-purple">
              <div class="bg_title" style="font-size:32px">
                <span>{{ $t("carbonIndex.bg_title_More")}}</span>
               <!-- <div v-if="login.groupId">
                  <span v-if="login.groupId == 1">{{ $t("carbonIndex.FriendShipCountryMena") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 2">{{ $t("carbonIndex.FriendShipCountryAsean") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 3"><span>China-Singapore({{login.country}})</span> <span style="font-weight:600">Carbon Neutrality</span> Connect</span>
                </div>
                <div v-else>
                  <span v-if="login.country == 'Pahang'">{{login.country ? login.country + ' State ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                  <span v-else>{{login.country ? login.country + ' National ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                </div> -->

              </div>
              <div class="Specs">
                A Digital Registry Powered by MVGX Technology
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div v-if="commandindex == 2">
              <!-- <img src="../../assets/img/cn_t.png" alt=""> -->
              <el-table
                :data="tonnesList"
                stripe
                :header-cell-style="{
                  background: '#F0F3F6',
                  color: '#626262',
                  fontSize: '14px',
                  fontFamily: 'ArialMT',
                  paddingTop: '17px',
                  paddingBottom: '15px',
                  paddingLeft:'20px'
                }"
                :cell-style="columnStyle"
                @row-click="getDetail"
                style="width: 100%"
              >
                
                <el-table-column prop="tonnes"  label="(Tonnes)">
                </el-table-column>
                <el-table-column prop="valueTwo"  label="2022">
                </el-table-column>
                <el-table-column
                  prop="valueOne"
                  label="2021"
                >
                </el-table-column>
              </el-table>
            </div>
            <div v-if="commandindex == 1">
              <div class="Specs" style="text-align:center">Your Carbon Neutrality Project Progress</div>
              <div class="steps">
                <el-steps :active="stepsCarbonCn" align-center finish-status="success">
                      <el-step description="Project Initiation"></el-step>
                      <el-step description="Carbon Footprint Quantification"></el-step>
                      <el-step description="Carbon Footprint Management Plan"></el-step>
                      <el-step description="Residual Carbon Emissions Offset"></el-step>
                      <el-step description="Certificate Issuance"></el-step>
                      <el-step description="NFT Creation"></el-step>
                  </el-steps>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="grid-content bg-purple ab_box">
          <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu_box" />
        </div>
      </div>
    </div>

    <!-- Carbon Neutrality -->
    <div class="mini_bg" v-else-if="index == 4">
      <div class="continer_width top_box">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="grid-content bg-purple">
              <div class="bg_title" style="font-size:32px">
                <span>{{ $t("carbonIndex.bg_title_More")}}</span>
                <!-- <div v-if="login.groupId">
                  <span v-if="login.groupId == 1">{{ $t("carbonIndex.FriendShipCountryMena") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 2">{{ $t("carbonIndex.FriendShipCountryAsean") }} ({{login.country}}) {{ $t("carbonIndex.bg_title_More") }}</span>
                  <span v-if="login.groupId == 3"><span>China-Singapore({{login.country}})</span> <span style="font-weight:600">Carbon Neutrality</span> Connect</span>
                </div>
                <div v-else>
                  <span v-if="login.country == 'Pahang'">{{login.country ? login.country + ' State ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                  <span v-else>{{login.country ? login.country + ' National ' : 'MetaVerse Green'}} {{ $t("carbonIndex.bg_title") }}</span>
                </div> -->

              </div>
              <div class="Specs">
                A Digital Registry Powered by MVGX Technology
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div>
              <div class="cf_title">{{login.country ? login.country + ' National ' : 'MetaVerse Green'}} Carbon Footprint Tool</div>
              <div class="cf_h3">Carbon Reporting is a tool for:</div>
              <div class="cf_h4">· <span style="font-weight:600">Organizations</span> to report their carbon emissions/removals to the National Authority; </div>
              <div class="cf_h4">· <span style="font-weight:600">National Authority</span> to report the national greenhouse gas inventory to the UN according </div>
              <div class="cf_h4">   to the Enhanced Transparency Framework(ETF) under the Paris Agreement</div>
            </div>
          </el-col>
        </el-row>
        <div class="grid-content bg-purple ab_box">
          <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu_box" />
        </div>
      </div>
    </div>



    <!-- Carbon Credits -->
    <div  :class="login.groupId == 3 ? 'mini_bg1' : 'mini_bg'" v-else>
      <div class="continer_width top_box">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="grid-content bg-purple">
              <div class="bg_title" style="font-size:32px">
                National Carbon Credit Registry
              </div>
              <div class="Specs">
                {{ $t("carbonIndex.tips") }}
              </div>
            </div>
            <div class="" v-if="login.groupId == 3">
              <el-row style="margin-bottom:20px">
                <el-col>
                  <img v-if="login.country == 'China'" src="../../assets/img/China-Singapore.png" alt="" style="width:796px;height:113px">
                  <img v-else src="../../assets/img/Singapore-China.png" alt="" style="width:796px;height:113px">
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <img src="../../assets/img/china-Singaproebiaoge.png" alt="" style="width:854px;height:s403px">
                </el-col>
              </el-row>
            </div>
            <div class="" v-else>
              <el-row type="flex" :gutter="20" style="margin-top: 20px">
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Total_Credits_Registered") }}
                    <div class="row_num">{{InfoHome.totalCreditsIssued ? addComma(InfoHome.totalCreditsIssued) : 0}}</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Total_Projects_Registered") }}
                    <div class="row_num">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Native_Registry_Credits") }}
                    <div class="row_num">{{InfoHome.nativeRegistryCredits ? addComma(InfoHome.nativeRegistryCredits) : 0}}</div>
                  </div>
                </el-col>
              </el-row>
              <!-- <el-row type="flex" :gutter="20" style="margin-top: 23px">
                <el-col>
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Tokenized_Credits") }}
                    <div class="row_num">
                      <span style="color: #1e1e1e">{{InfoHome.tokenizedCredits ? addComma(InfoHome.tokenizedCredits) : 0}} </span>
                    </div>
                  </div>
                </el-col>
                <el-col>
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.CNTS") }}
                    <div class="row_num">
                      {{InfoHome.cnts ? addComma(InfoHome.cnts) : 0}}
                    </div>
                  </div>
                </el-col>
                <el-col>
                  <div class="grid-content bg-purple row_title">
                      {{ $t("carbonIndex.C_CNTS") }}
                    <div class="row_num">
                      {{InfoHome.ccnts ? addComma(InfoHome.ccnts) : 0}}
                    </div>
                  </div>
                </el-col>
              </el-row> -->
              <el-row type="flex" :gutter="20" style="margin-top: 20px">
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Number_of_Registered_Users") }}
                    <div class="row_num">{{InfoHome.numberOfRegisteredUsers ? addComma(InfoHome.numberOfRegisteredUsers) : 0}}</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Connected_Registries") }}
                    <div class="row_num">{{InfoHome.connectedRegistries ? addComma(InfoHome.connectedRegistries) : 0}}</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple row_title">
                    {{ $t("carbonIndex.Connected_Exchanges") }}
                    <div class="row_num">{{InfoHome.connectedExchanges ? addComma(InfoHome.connectedExchanges) : 0}}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <!-- <el-col :span="5">
            <div class="grid-content bg-purple">
              <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu" />
            </div>
          </el-col> -->
        </el-row>
        <div class="grid-content bg-purple  " :class="login.groupId == 3 ? 'ab_box1' : 'ab_box'">
          <img src="../../assets/img/bg_tu.png" alt="" class="bg_tu_box" />
        </div>
      </div>
    </div>


    


    
    <!-- tab切换 -->
    <div class="tab_bg">
      <el-row type="flex" justify="space-between" class="continer_width">
        <el-col>
          <span class="tab_item" :class="index == 1 ? 'tab_sel' : ''" @click="tab(1)">
            {{ $t("carbonIndex.Carbon_Credit_Registry") }}
          </span>
          <span class="tab_item" :class="index == 2 ? 'tab_sel' : ''" @click="tab(2)">
            {{ $t("carbonIndex.Carbon_Footprint_Registry") }}
          </span>
          <span class="tab_item" :class="index == 3 ? 'tab_sel' : ''" style="margin-right:0">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="tab_item" :class="index == 3 ? 'tab_sel' : ''">{{ $t("carbonIndex.Carbon_Neutrality_Registry") }}</span>
              <el-dropdown-menu slot="dropdown" class="dropdown_header">
                <el-dropdown-item command="2">For National Authority</el-dropdown-item>
                <el-dropdown-item command="1">For Organizations</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span class="tab_item" :class="index == 4 ? 'tab_sel' : ''" style="margin-right:0">
            <el-dropdown trigger="click" @command="handleCommand4">
              <span class="tab_item" :class="index == 4 ? 'tab_sel' : ''">{{ $t("carbonIndex.Carbon_Reporting") }}</span>
              <el-dropdown-menu slot="dropdown" class="dropdown_header">
                <el-dropdown-item command="1">For National Authority</el-dropdown-item>
                <el-dropdown-item command="2">For Organizations</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <!-- <span class="tab_item" :class="index == 5 ? 'tab_sel' : ''" @click="login.security.all && tab(5)">
            {{ $t("carbonIndex.Exchange_Service") }}
          </span> -->
        </el-col>
      </el-row>
    </div>
    
    <!-- content -->
    <div class="mini_content continer_width m_100" >
      <el-row type="flex" v-if="index == 1" :gutter="20" justify="space-between">
        <!-- 左侧 -->
        <el-col :span="10" class="left">
          
          <el-collapse v-model="activeName" @change="handleChange" accordion>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 2 }"
              :title="$t('carbonIndex.Carbon_Projects')"
              name="2"
            >
              <div class="Tokenize">
                <el-collapse v-model="active" @change="handleChangeProject" accordion class="one">
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Initiate_New_Projects')" name="1" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Credits_Adjustments')" name="2" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Generate_CNTs')" name="3" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Generate_C_CNTs')" name="4" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Tokenize')" name="5">
                    <div class="projects">
                      <el-form class="form">
                        <el-form-item :label="$t('carbonIndex.ID')">
                          <el-input v-model="form.projectSiteId" min="0"  oninput="value=value.replace(/[^\d.]/g,'')" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('carbonIndex.NAME')">
                          <el-input v-model="form.projectName"></el-input>
                        </el-form-item>
                        <el-collapse v-model="activeNames">
                          <el-collapse-item
                            :title="$t('carbonIndex.Project_Type')"
                            name="1"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="typeSel == index ? 'overviewSel selbg' : ''"
                                  @click="changeType(index)"
                                  v-for="(item, index) in typeList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            :title="$t('carbonIndex.Methodology')"
                            name="2"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="
                                    methodologySel == index ? 'overviewSel selbg' : ''
                                  "
                                  @click="changeMethodology(index)"
                                  v-for="(item, index) in methodologyList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.type == 1"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.Country')"
                            name="3"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="countrySel == index ? 'overviewSel selbg' : ''"
                                  @click="changeCountry(index)"
                                  v-for="(item, index) in countryList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.type == 2"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.province')"
                            name="3"
                          >
                            <div class="Country">
                              <el-checkbox-group v-model="provinceStateSel" >
                                <el-checkbox v-for="(item, index) in provinceState" :key="index" :label="item">- {{item}}</el-checkbox>
                              </el-checkbox-group>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 1"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.mena')"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountry"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 2"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.asean')"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountryAsean"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 3"
                            :title="login.currncy ? login.currncy : 'China-Singapore'"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountryChina"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                        </el-collapse>
                        <div class="display_flex bth-wrap">
                          <el-button class="bths bthClear" @click="clearSearch">{{
                            $t("carbonIndex.Reset_Search")
                          }}</el-button>
                          <el-button class="bths" @click="search">{{
                            $t("carbonIndex.Search")
                          }}</el-button>
                        </div>
                      </el-form>
                    </div>
                  </el-collapse-item>
                  
                  
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 3 }"
              :title="$t('carbonIndex.Carbon_Credits')"
              name="3"
            >
              <div class="Tokenize ">
                <el-collapse v-model="creditssel" @change="changeCreditsSel" accordion class=" three" >
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_one')" name="1" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_two')" name="2" v-if="login.security.all">
                    <div class="Tokenize TokenizeCarbon">
                      <el-collapse v-model="tokenCarbonSel" @change="changeTokenCarbonSel" accordion class="one">
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_Token_National')" name="1">
                        </el-collapse-item>
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_Token_Neutrality')" name="2">
                        </el-collapse-item>
                        <el-collapse-item :title="'- '+ $t('carbonIndex.three_token_compliance')" name="3">
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Cancel_Carbon')" name="5" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_three')" name="3" v-if="login.security.all">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.three_four')" name="4" >
                    <div class="projects">
                      <el-form class="form">
                        <el-form-item :label="$t('carbonIndex.ID')">
                          <el-input v-model="form.projectSiteId" min="0"  oninput="value=value.replace(/[^\d.]/g,'')" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('carbonIndex.NAME')">
                          <el-input v-model="form.projectName"></el-input>
                        </el-form-item>
                        <el-collapse v-model="activeNames">
                          <el-collapse-item
                            :title="$t('carbonIndex.Project_Type')"
                            name="1"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="typeSel == index ? 'overviewSel selbg' : ''"
                                  @click="changeType(index)"
                                  v-for="(item, index) in typeList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            :title="$t('carbonIndex.Methodology')"
                            name="2"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="
                                    methodologySel == index ? 'overviewSel selbg' : ''
                                  "
                                  @click="changeMethodology(index)"
                                  v-for="(item, index) in methodologyList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.type == 1"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.Country')"
                            name="3"
                          >
                            <div>
                              <ul class="Country">
                                <li
                                  :class="countrySel == index ? 'overviewSel selbg' : ''"
                                  @click="changeCountry(index)"
                                  v-for="(item, index) in countryList"
                                  :key="index"
                                >
                                  - {{ item }}
                                </li>
                              </ul>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.type == 2"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.province')"
                            name="3"
                          >
                            <div class="Country">
                              <el-checkbox-group v-model="provinceStateSel" >
                                <el-checkbox v-for="(item, index) in provinceState" :key="index" :label="item">- {{item}}</el-checkbox>
                              </el-checkbox-group>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 1"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.mena')"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountry"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 2"
                            :title="login.currncy ? login.currncy : $t('carbonIndex.asean')"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountryAsean"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                          <el-collapse-item
                            v-if="login.groupId && login.groupId == 3"
                            :title="login.currncy ? login.currncy : 'China-Singapore'"
                            name="4"
                          >
                            <ul class="Country" >
                              <li
                                :class="
                                  friendShipCountrySel == index ? 'overviewSel selbg' : ''
                                "
                                @click="changeFriendShipCountry(index)"
                                v-for="(item, index) in friendShipCountryChina"
                                :key="index"
                              >
                                - {{ item }}
                              </li>
                            </ul>
                          </el-collapse-item>
                        </el-collapse>
                        <div class="display_flex bth-wrap">
                          <el-button class="bths bthClear" @click="clearSearch">{{
                            $t("carbonIndex.Reset_Search")
                          }}</el-button>
                          <el-button class="bths" @click="search">{{
                            $t("carbonIndex.Search")
                          }}</el-button>
                        </div>
                      </el-form>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>

            </el-collapse-item>
            <el-collapse-item
              :class="{ aaa: currentActiveName == 4 }"
              :title="$t('carbonIndex.Carbon_Credit_Transactions')"
              name="4"
              v-if="login.security.all"
            >
              <div class="Tokenize ">
                <el-collapse v-model="transactionsSel" @change="changeTransactions" accordion class=" three">
                  <el-collapse-item :title="'- '+ $t('carbonIndex.OwnershipTrades')" name="1">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Corresponding_Adjustments')" name="2">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ $t('carbonIndex.Domestic')" name="3">
                    <div class="Tokenize TokenizeCarbon">
                      <el-collapse v-model="MakeCarbonSel" @change="changeMakeCarbonSel" accordion class="one">
                        <el-collapse-item :title="'- '+ $t('carbonIndex.ConventionalCarbonCreditTransactions')" name="1">
                        </el-collapse-item>
                        <el-collapse-item :title="'- '+ $t('carbonIndex.TokenizedCarbonCredit')" name="2">
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>

            </el-collapse-item>
             

            <!-- 2023-03-03 NEA -->
            <el-collapse-item
              :class="{ aaa: currentActiveName == 6 }"
              title="Carbon Credit Retirement"
              name="6"
              v-if="login.security.all"
            >
              <div class="Tokenize ">
                <el-collapse v-model="carbonCreditIndex" @change="changeCarbonCreditIndex" accordion class=" three">
                  <el-collapse-item :title="'- '+ 'Carbon Credits in IOP Registry'" name="1">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ 'Carbon Credit Retirement Request'" name="2">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ 'Carbon Credit Retirement Management'" name="3">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>

            <el-collapse-item
              :class="{ aaa: currentActiveName == 7 }"
              title="Carbon Credit Transfer"
              name="7"
              v-if="login.security.all"
            >
              <div class="Tokenize ">
                <el-collapse v-model="carbonTransferIndex" @change="changeCarbonTransferIndex" accordion class=" three">
                  <el-collapse-item :title="'- '+ 'Carbon Credit Transfer Request'" name="1">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ 'Carbon Credit Transfer Review'" name="2">
                  </el-collapse-item>
                  <el-collapse-item :title="'- '+ 'ICCs in Agency Account'" name="3">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>

            <el-collapse-item
              :class="{ aaa: currentActiveName == 8 }"
              title="System Log"
              name="8"
              v-if="login.security.all"
            >
            </el-collapse-item>

            <el-collapse-item
              :class="{ aaa: currentActiveName == 5 }"
              :title="$t('carbonIndex.nfdt_Ledger')"
              name="5"
            >
            <div class="projects">
              <el-form class="form">
                <el-form-item :label="$t('carbonIndex.ID')">
                  <el-input v-model="form.projectSiteId" min="0"  oninput="value=value.replace(/[^\d.]/g,'')" ></el-input>
                </el-form-item>
                <el-form-item :label="$t('carbonIndex.NAME')">
                  <el-input v-model="form.projectName"></el-input>
                </el-form-item>
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    :title="$t('carbonIndex.Project_Type')"
                    name="1"
                  >
                    <div>
                      <ul class="Country">
                        <li
                          :class="typeSel == index ? 'overviewSel selbg' : ''"
                          @click="changeType(index)"
                          v-for="(item, index) in typeList"
                          :key="index"
                        >
                          - {{ item }}
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item
                    :title="$t('carbonIndex.Methodology')"
                    name="2"
                  >
                    <div>
                      <ul class="Country">
                        <li
                          :class="
                            methodologySel == index ? 'overviewSel selbg' : ''
                          "
                          @click="changeMethodology(index)"
                          v-for="(item, index) in methodologyList"
                          :key="index"
                        >
                          - {{ item }}
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item
                    v-if="login.type == 1"
                    :title="login.currncy ? login.currncy : $t('carbonIndex.Country')"
                    name="3"
                  >
                    <div>
                      <ul class="Country">
                        <li
                          :class="countrySel == index ? 'overviewSel selbg' : ''"
                          @click="changeCountry(index)"
                          v-for="(item, index) in countryList"
                          :key="index"
                        >
                          - {{ item }}
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item
                    v-if="login.type == 2"
                    :title="login.currncy ? login.currncy : $t('carbonIndex.province')"
                    name="3"
                  >
                    <div class="Country">
                      <el-checkbox-group v-model="provinceStateSel" >
                        <el-checkbox v-for="(item, index) in provinceState" :key="index" :label="item">- {{item}}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </el-collapse-item>
                  
                  <el-collapse-item
                    v-if="login.groupId && login.groupId == 1"
                    :title="login.currncy ? login.currncy : $t('carbonIndex.mena')"
                    name="4"
                  >
                    <ul class="Country" >
                      <li
                        :class="
                          friendShipCountrySel == index ? 'overviewSel selbg' : ''
                        "
                        @click="changeFriendShipCountry(index)"
                        v-for="(item, index) in friendShipCountry"
                        :key="index"
                      >
                        - {{ item }}
                      </li>
                    </ul>
                  </el-collapse-item>
                  <el-collapse-item
                    v-if="login.groupId && login.groupId == 2"
                    :title="login.currncy ? login.currncy : $t('carbonIndex.asean')"
                    name="4"
                  >
                    <ul class="Country" >
                      <li
                        :class="
                          friendShipCountrySel == index ? 'overviewSel selbg' : ''
                        "
                        @click="changeFriendShipCountry(index)"
                        v-for="(item, index) in friendShipCountryAsean"
                        :key="index"
                      >
                        - {{ item }}
                      </li>
                    </ul>
                  </el-collapse-item>
                  <el-collapse-item
                    v-if="login.groupId && login.groupId == 3"
                    :title="login.currncy ? login.currncy : 'China-Singapore'"
                    name="4"
                  >
                    <ul class="Country" >
                      <li
                        :class="
                          friendShipCountrySel == index ? 'overviewSel selbg' : ''
                        "
                        @click="changeFriendShipCountry(index)"
                        v-for="(item, index) in friendShipCountryChina"
                        :key="index"
                      >
                        - {{ item }}
                      </li>
                    </ul>
                  </el-collapse-item>
                </el-collapse>
                <div class="display_flex bth-wrap">
                  <el-button class="bths bthClear" @click="clearSearch">{{
                    $t("carbonIndex.Reset_Search")
                  }}</el-button>
                  <el-button class="bths" @click="search">{{
                    $t("carbonIndex.Search")
                  }}</el-button>
                </div>
              </el-form>
            </div>
              <!-- <ul class="Country1">
                <li
                  @click="changeTransactions(1)"
                  :class="transactionsSel == 1 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.OwnershipTrades") }}
                </li>
                <li
                  @click="changeTransactions(2)"
                  :class="transactionsSel == 2 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Corresponding_Adjustments") }}
                </li>
                <li
                  @click="changeTransactions(3)"
                  :class="transactionsSel == 3 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Domestic") }}
                </li>
                <li
                  @click="changeTransactions(4)"
                  :class="transactionsSel == 4 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Permanent") }}
                </li>
                <li
                  @click="changeTransactions(5)"
                  :class="transactionsSel == 5 ? 'overviewSel' : ''"
                >
                  - {{ $t("carbonIndex.Cancel_Carbon") }}
                </li>
              </ul> -->
            </el-collapse-item>
          </el-collapse>
          
          <!-- <div class="logOut">{{$t('carbonIndex.logOUt')}}</div> -->
        </el-col>
        <!-- 右侧 -->
        <el-col>
          <div class="" v-if="currentActiveName == 1">
          </div>
          <div v-if="currentActiveName == 2">
            <div
              class="threeWrap"
              v-if="active  == null"
            >
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Registered_Carbon_Projects") }}<span v-if="login.groupId == 3"> {{'(China + Singapore)'}}</span><span v-if="login.groupId == 2"> {{'(MENA)'}}</span>
                  </div>
                </el-row>
                <el-row>
                  <!-- 地图 -->
                  <div class="map_box" id="maps">
                    <MAPS/>
                  </div>
                </el-row>
                <el-row type="flex" justify="space-between" class="one" style="margin-top:30px">
                  <el-col class="name"><span v-if="login.groupId"> {{login.country}} </span>{{
                    $t("carbonIndex.Registered_Projects")
                  }}</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.developedNationalRegistry ? addComma(InfoHome.developedNationalRegistry) : 0}}</el-col>
                </el-row>
                <el-row type="flex" justify="space-between" class="one">
                  <el-col class="name"><span v-if="login.groupId"> {{login.country}} </span>{{
                    $t("carbonIndex.Registered_Projects_Introduced")
                  }}</el-col>
                  <!-- <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col> -->
                  <el-col class="nums" style="text-align:left" :span="6">0</el-col>
                </el-row>

              </div>
              <div class="overview_wrap" style="margin-top:30px">
                  <el-row>
                    <div class="title">
                      {{ $t("carbonIndex.Carbon_Projects_Overview") }}
                    </div>
                  </el-row>
                  <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Total_Projects_Registered")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                    <el-col></el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row>
                    <div class="title" style="font-size:24px;margin-top:30px">
                      {{ $t("carbonIndex.Developing_Native_Registry_Projects") }}
                    </div>
                  </el-row>
                  <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Project_Documents_Submitted")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.projectDocumentsSubmitted ? addComma(InfoHome.projectDocumentsSubmitted) : 0}}</el-col>
                      </el-row>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Project_in_Implementation")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.projectsInImplementation ? addComma(InfoHome.projectsInImplementation) : 0}}</el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Project_Documents_Approved")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.projectDocumentsApproved ? addComma(InfoHome.projectDocumentsApproved) : 0}}</el-col>
                      </el-row>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Projects_Verification")
                        }}</el-col>
                        <el-col class="nums" :span="2">{{InfoHome.projectRegistered ? addComma(InfoHome.projectRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row>
                    <div class="title" style="font-size:24px;margin-top:30px">
                      {{ $t("carbonIndex.Imported_Projects") }}
                    </div>
                  </el-row>
                  <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-row type="flex" justify="space-between" style="margin-bottom:39px" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Projects_Registries")
                        }}</el-col>
                        <el-col class="nums" :span="8">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row type="flex" justify="space-between" style="margin-bottom:39px" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Projects_Imported_and_Registered")
                        }}</el-col>
                        <el-col class="nums" :span="8">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Projects_under_Review")
                        }}</el-col>
                        <el-col class="nums" :span="8">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Projects_Registered_Review")
                        }}</el-col>
                        <el-col class="nums" :span="8">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-divider></el-divider>
                  <el-row>
                    <div class="title" style="font-size:24px;margin-top:30px">
                      {{ $t("carbonIndex.Projects_with_Credits") }}
                    </div>
                  </el-row>
                  <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Project_with_Credits_Pending")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.totalProjectsRegistered ? addComma(InfoHome.totalProjectsRegistered) : 0}}</el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row type="flex" justify="space-between" class="one">
                        <el-col class="name">{{
                          $t("carbonIndex.Project_including")
                        }}</el-col>
                        <el-col class="nums" :span="6">{{InfoHome.projectsWithPendingCredits ? addComma(InfoHome.projectsWithPendingCredits) : 0}}</el-col>
                      </el-row>
                    </el-col>
                  </el-row>
              </div>

              <!-- 底部数据，暂时隐藏 -->
              <!-- <div class="overview_wrap" style="margin-top:30px">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Carbon_Credits_Overview") }}
                  </div>
                </el-row>
                <el-row type="flex" justify="space-between" :gutter="80">
                  <el-col class="border">
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Total_Credits_Registered")
                      }}</el-col>
                      <el-col class="nums" :span="6">5,467,120</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Pending_Credits")
                      }}</el-col>
                      <el-col class="nums" :span="6">1,583,000</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Native_Registry_Credits_Issued")
                      }}</el-col>
                      <el-col class="nums" :span="6">4,500,000</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Credits_Retired")
                      }}</el-col>
                      <el-col class="nums" :span="6">455,000</el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Retired_Credits")
                      }}</el-col>
                      <el-col class="nums" :span="6">1,350,000</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{
                        $t("carbonIndex.Tokenized_Credits")
                      }}</el-col>
                      <el-col class="nums" :span="6">4,047,830</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{ $t("carbonIndex.CNTs") }}</el-col>
                      <el-col class="nums" :span="6">1,245,000</el-col>
                    </el-row>
                    <el-row type="flex" justify="space-between" class="one">
                      <el-col class="name">{{ $t("carbonIndex.C_CNTs") }}</el-col>
                      <el-col class="nums" :span="6">0</el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div> -->

            
            </div>
            <!-- table表格 -->
            <div v-if="active == 5">
              <el-table
                :data="
                  tableData.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                  )
                "
                stripe
                :header-cell-style="{
                  background: '#F0F3F6',
                  color: '#626262',
                  fontSize: '14px',
                  fontFamily: 'ArialMT',
                  paddingTop: '17px',
                  paddingBottom: '15px',
                  paddingLeft:'20px'
                }"
                :cell-style="columnStyle"
                @row-click="getDetail"
                style="width: 100%"
              >
                <!-- 空状态 -->
                <template slot="empty">
                  <p style="margin-top: 50px">
                    <img
                      class="data-pic"
                      src="../../assets/img/noData.png"
                      alt=""
                    />
                  </p>
                  <p class="nodata">{{ $t("carbonIndex.noData") }}</p>
                </template>
                <el-table-column prop="id" width="80px" :label="$t('carbonIndex.ID')">
                </el-table-column>
                <el-table-column prop="name" width="200px" :label="$t('carbonIndex.Name')">
                </el-table-column>
                <el-table-column
                  prop="country"
                  :label="$t('carbonIndex.Country')"
                  v-if="login.type == 1 || login.groupId"
                >
                </el-table-column>
                <el-table-column
                  prop="state"
                  :label="$t('carbonIndex.province')"
                  v-if="login.type == 2"
                >
                </el-table-column>
                
                <el-table-column
                  prop="quantity"
                  :label="$t('carbonIndex.Quantity')"
                >
                  <template slot-scope="scope">
                    {{addComma(scope.row.quantity)}}
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="issued"
                  :label="$t('carbonIndex.Date_Issued')"
                  
                >
                  <template slot-scope="scope">
                    {{ scope.row.issued ? formatDate(scope.row.issued) : '--'}}
                  </template>
                </el-table-column> -->
                <el-table-column
                  width="200px"
                  prop="creditingPeriod"
                  :label="$t('carbonIndex.cpiod')"
                >
                <template slot-scope="scope">
                    {{  scope.row.creditingPeriod ?  scope.row.creditingPeriod : '--'}}
                  </template>
                </el-table-column>

              </el-table>
              <div class="display_flex dis_end" style="margin-top: 47px">
                <el-pagination
                  v-if="tableData.length != 0"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  background
                  layout="prev, pager, next"
                  class="pagination"
                  prev-text="<"
                  next-text=">"
                  :total="tableData.length"
                >
                </el-pagination>
              </div>
            </div>

            <div v-if="active == 2">
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    Projects from External Registries
                  </div>
                </el-row>
                <el-table
                  :data="
                    projectsIntroducedList.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )
                  "
                  stripe
                  :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '14px',
                    fontFamily: 'ArialMT',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    paddingLeft:'20px'
                  }"
                  :cell-style="columnStyle"
                  @row-click="getDetail"
                  style="width: 100%"
                >
                  <!-- 空状态 -->
                  <template slot="empty">
                    <p style="margin-top: 50px">
                      <img
                        class="data-pic"
                        src="../../assets/img/noData.png"
                        alt=""
                      />
                    </p>
                    <p class="nodata">No Data</p>
                  </template>
                  <el-table-column prop="id"  :label="$t('carbonIndex.registries_ID')">
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('carbonIndex.registries_Name')">
                  </el-table-column>
                  <el-table-column
                    prop="externalRegistry"
                    :label="$t('carbonIndex.registries_Ex')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="externalRegistryId"
                    :label="$t('carbonIndex.registries_Exid')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="quantity"
                    :label="$t('carbonIndex.registries_Credits')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="creditingPeriod"
                    :label="$t('carbonIndex.registries_CrePer')"
                  >
                  </el-table-column>
                  
                  <el-table-column
                    width="200px"
                    prop="projectStatus"
                    :label="$t('carbonIndex.registries_Status')">
                  </el-table-column>
                </el-table>
                <div class="display_flex dis_end" style="margin-top: 47px">
                  <el-pagination
                    v-if="projectsIntroducedList.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="projectsIntroducedList.length"
                  >
                  </el-pagination>
                </div>
              </div>
               
            </div>

            <div v-if="active == 3">
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Registered_Carbon_Projects_CMS_CC") }}
                  </div>
                </el-row>
                <el-table
                  :data="
                    cmccprojectsIntroducedList.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )
                  "
                  stripe
                  :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '14px',
                    fontFamily: 'ArialMT',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    paddingLeft:'20px'
                  }"
                  :cell-style="columnStyle"
                  @row-click="getDetail"
                  style="width: 100%"
                >
                  <!-- 空状态 -->
                  <template slot="empty">
                    <p style="margin-top: 50px">
                      <img
                        class="data-pic"
                        src="../../assets/img/noData.png"
                        alt=""
                      />
                    </p>
                    <p class="nodata">No Data</p>
                  </template>
                  <el-table-column prop="id"  :label="$t('carbonIndex.registries_ID')">
                  </el-table-column>
                  <el-table-column prop="name" width="130" :label="$t('carbonIndex.CMCC_registries_Name')">
                  </el-table-column>
                  <el-table-column prop="externalRegistry"  :label="$t('carbonIndex.CMCC_registries_Ex')">
                  </el-table-column>
                  <el-table-column prop="externalRegistryId"  :label="$t('carbonIndex.CMCC_registries_Exid')">
                  </el-table-column>
                  <el-table-column prop="quantity" width="150" :label="$t('carbonIndex.CMCC_registries_Credits')">
                  </el-table-column>
                  <el-table-column
                    prop="creditingPeriod"
                    :label="$t('carbonIndex.registries_CrePer')"
                  >
                  </el-table-column>
                  
                  <el-table-column
                    width="200px"
                    prop="projectStatus"
                    :label="$t('carbonIndex.registries_Status')">
                  </el-table-column>
                </el-table>
                <div class="detial_box">
                  <div class="detail_txt">{{$t('carbonIndex.CMCC_DETAIL_TXT')}}</div>
                </div>
                <div class="display_flex dis_end" style="margin-top: 47px">
                  <el-pagination
                    v-if="projectsIntroducedList.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="projectsIntroducedList.length"
                  >
                  </el-pagination>
                </div>
                
              </div>
               
            </div>

            <div class="" v-if="active == 4">
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Projects_with_Approval_Action_Pending") }}
                  </div>
                </el-row>
                <el-table
                  :data="
                    mamageProjectList.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )
                  "
                  stripe
                  :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '14px',
                    fontFamily: 'ArialMT',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    paddingLeft:'20px'
                  }"
                  style="width: 910px;max-width:910px"
                  :cell-style="columnStyle"
                >
                  <!-- 空状态 -->
                  <template slot="empty">
                    <p style="margin-top: 50px">
                      <img
                        class="data-pic"
                        src="../../assets/img/noData.png"
                        alt=""
                      />
                    </p>
                    <p class="nodata">No Data</p>
                  </template>
                  <el-table-column prop="date" width="150" :label="$t('carbonIndex.RequestDate')">
                  </el-table-column>
                  <el-table-column prop="ActionRequested" width="150" :label="$t('carbonIndex.ActionRequested')">
                  </el-table-column>
                  <el-table-column
                    prop="id"
                    width="150"
                    :label="$t('carbonIndex.projectId')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="projectName"
                    width="150"
                    :label="$t('carbonIndex.manProjectName')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="projectProponent"
                    width="150"
                    :label="$t('carbonIndex.projectProponent')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="projectvvb"
                    width="150"
                    :label="$t('carbonIndex.projectvvb')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="NumberofCredits"
                    width="150"
                    :label="$t('carbonIndex.Number_of_Credits')"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="DocumentsSubmitted"
                    width="150"
                    :label="$t('carbonIndex.DocumentsSubmitted')">
                  </el-table-column>
                   <el-table-column
                    prop="manProjectAddress"
                    width="150"
                    :label="$t('carbonIndex.manProjectAddress')">
                      <template  slot-scope="scope">
                        <span style="color:#158869;">
                          <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/address/' + scope.row.manProjectAddress" >{{scope.row.manProjectAddress}}</a>
                        </span>
                      </template>
                  </el-table-column> 
                  <el-table-column
                    prop="projectStatus"
                    fixed="right"
                    width="150"
                    :label="$t('carbonIndex.TakeAction')">
                    <template >
                      <div style="margin:0 auto">
                        <div class="request_btn">{{$t('carbonIndex.Request_more_Info')}}</div>
                        <div class="request_btn btn_green">{{$t('carbonIndex.Approve')}}</div>
                        <div class="request_btn btn_orage">{{$t('carbonIndex.Decline')}}</div>
                      </div>
                      
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="display_flex dis_end" style="margin-top: 47px">
                  <el-pagination
                    v-if="projectsIntroducedList.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="projectsIntroducedList.length"
                  >
                  </el-pagination>
                </div> -->
              </div>
            </div>
          </div>

          <div class="newProject" v-if="currentActiveName == 2 && active == 1">
            <div class="overview_wrap">
              <el-row>
                <div class="title">
                  {{ $t("carbonIndex.new_Project_title") }}
                </div>
              </el-row>
              <el-row>
                <!-- table表格 -->
                <div>
                  <el-table
                    :data="initiativeNewProjectList"
                    stripe
                    :header-cell-style="{
                      background: '#F0F3F6',
                      color: '#626262',
                      fontSize: '14px',
                      fontFamily: 'ArialMT',
                      paddingTop: '17px',
                      paddingBottom: '15px',
                      paddingLeft:'20px'
                    }"
                    :cell-style="columnStyle"
                    style="width: 100%"
                  >
                    <el-table-column prop="step"  :label="$t('carbonIndex.Steps')">
                      <template slot-scope="scope" >
                        <div class="listStep">
                          <div>{{scope.$index +1}}.</div>
                          {{scope.row.step}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="ResponsibleParties"  :label="$t('carbonIndex.Responsible_Parties')">
                    </el-table-column>
                    <el-table-column
                      prop="action"
                      :label="$t('carbonIndex.Action')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="documents"
                      :label="$t('carbonIndex.Documents_Required')"
                    >
                    <template slot-scope="scope">
                      <span >{{scope.row.documents}}</span>
                      
                      <div class="documentupload" @click="documentUploadShow  = true" v-if="(scope.$index +1 !== 5) && (scope.$index +1 !== 6) && (scope.$index +1 !== 8) && (scope.$index +1 !== 9) && (scope.$index +1 !== 10)">
                        <img src="../../assets/img/xia.png" alt="">
                        {{$t('carbonIndex.documentupload')}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="nodeAddress"
                      :label="$t('carbonIndex.NFDT_Node_Address')"
                    >
                      <template  slot-scope="scope">
                        <span style="color:#158869;">
                          <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/address/' + scope.row.nodeAddress" >{{scope.row.nodeAddress}}</a>
                        </span>
                          
                      </template>
                      
                    </el-table-column>

                  </el-table>
                  <div class="detial_box">
                    <div class="detail_txt">{{$t("carbonIndex.New_ProjectDetailPDD")}}</div>
                    <div class="detail_txt">{{$t("carbonIndex.New_ProjectDetailVVB")}}</div>
                  </div>
                </div>
              </el-row>



              <!-- <el-form :label-position="labelPosition">
                <el-row type="flex" justify="space-between" :gutter="80">
                    <el-col>
                      <el-form-item :label="$t('carbonIndex.Project_Name')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.name" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Country')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.country" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Project_Developer')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.developer" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Credit_Standards')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.standards" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Crediting_Period')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.period" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item :label="$t('carbonIndex.Project_Type')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.type" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Province_State')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.state" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Project_Verifier')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.verifier" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Credit_Methodology')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.methodology" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                      <el-form-item :label="$t('carbonIndex.Annual_Credits')">
                        <el-row type="flex" justify="space-between" class="one">
                            <el-input v-model="data.credits" :placeholder="$t('carbonIndex.enter')"></el-input>
                        </el-row>
                      </el-form-item>
                    </el-col>
                  
                </el-row>
              </el-form>

              <el-row type="flex" justify="space-between" style="margin-top:50px">
                <el-col>
                  <el-button class="upload">
                    <img src="../../assets/img/xia.png" alt="">
                    {{$t('carbonIndex.Document_Upload')}}</el-button>
                </el-col>
                <el-col style="text-align:right">
                  <el-button class="cancel confirm">{{$t('carbonIndex.Cancel')}}</el-button>
                  <el-button class="cancel ">{{$t('carbonIndex.Confirm')}}</el-button>
                </el-col>
              </el-row> -->
            </div>
          </div>

         <div class="overview_wrap" v-if="currentActiveName == 5">
            <div >
              <el-table
                :data="
                  nfdtSearchList.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                  )
                "
                stripe
                :header-cell-style="{
                  background: '#F0F3F6',
                  color: '#626262',
                  fontSize: '14px',
                  fontFamily: 'ArialMT',
                  paddingTop: '17px',
                  paddingBottom: '15px',
                  paddingLeft:'20px'
                }"
                :cell-style="columnStyle"
                @row-click="getnfdtDetail"
                style="width: 100%"
              >
                <template slot="empty">
                  <p style="margin-top: 50px">
                    <img
                      class="data-pic"
                      src="../../assets/img/noData.png"
                      alt=""
                    />
                  </p>
                  <p class="nodata">No data</p>
                </template>
                <el-table-column prop="id" :label="$t('carbonIndex.nfdtId')">
                </el-table-column>
                <el-table-column prop="name"  :label="$t('carbonIndex.nfdtName')">
                </el-table-column>
                <el-table-column
                  prop="country"
                  :label="$t('carbonIndex.nfdtCountry')"
                >
                </el-table-column>
                <el-table-column
                  prop="projectType"
                  :label="$t('carbonIndex.nfdtProjectType')"
                >
                </el-table-column>

              </el-table>
              <div class="display_flex dis_end" style="margin-top: 47px">
                <el-pagination
                  v-if="nfdtSearchList.length != 0"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  background
                  layout="prev, pager, next"
                  class="pagination"
                  prev-text="<"
                  next-text=">"
                  :total="nfdtSearchList.length"
                >
                </el-pagination>
              </div>
            </div>
         </div>
          

          <div v-if="currentActiveName == 3">
            <div
              class="threeWrap"
              v-if="creditssel  == null"
            >
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Projects_with_Issued_Carbon_Credits") }}<span v-if="login.groupId == 3"> {{'(China + Singapore)'}}</span><span v-if="login.groupId == 2"> {{'(ASEAN)'}}</span>
                  </div>
                </el-row>
                <el-row>
                  <!-- 地图 -->
                  <div class="map_box" id="maps">
                    <MAPS/>
                  </div>
                </el-row>
                <div class="title" style="text-align:center;margin-top:20px" v-if="login.groupId"> {{login.country}}</div>
                <el-row type="flex" justify="space-between" class="one" style="margin-top:30px">
                  <el-col class="name">{{
                    $t("carbonIndex.three_Carbon_Credits")
                  }}</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.totalCreditsIssued ? addComma(InfoHome.totalCreditsIssued) : 0}}</el-col>
                  <el-col class="name">{{
                    $t("carbonIndex.three_CNTs")
                  }}</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.cnts ? addComma(InfoHome.cnts) : 0}}</el-col>
                </el-row>
                <el-row type="flex" justify="space-between" class="one">
                  <el-col class="name">{{
                    $t("carbonIndex.three_Tokenized_Carbon_Credits")
                  }}</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.tokenizedCredits ? addComma(InfoHome.tokenizedCredits) : 0}}</el-col>
                  <el-col class="name">{{
                    $t("carbonIndex.three_C_CNTs")
                  }}</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">{{InfoHome.ccnts ? addComma(InfoHome.ccnts) : 0}}</el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <img src="../../assets/img/biao2.png" alt="">
                  </el-col>
                </el-row>
              </div>
            </div>

            <div class="overview_wrap" v-if="creditssel == 1">
              <!-- table表格 -->
              <div >
                <el-table
                  :data="
                    issueList.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )
                  "
                  stripe
                  :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '14px',
                    fontFamily: 'ArialMT',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    paddingLeft:'20px'
                  }"
                  :cell-style="columnStyle"
                  style="width: 100%"
                >
                  <!-- 空状态 -->
                  <template slot="empty">
                    <p style="margin-top: 50px">
                      <img
                        class="data-pic"
                        src="../../assets/img/noData.png"
                        alt=""
                      />
                    </p>
                    <p class="nodata">No Data</p>
                  </template>
                  <el-table-column prop="id" :label="$t('carbonIndex.mvgxID')">
                  </el-table-column>
                  <el-table-column prop="projectName" :label="$t('carbonIndex.mvgxnAME')">
                  </el-table-column>
                  <el-table-column prop="annualCredits" :label="$t('carbonIndex.mvgxCredits')">
                    <template slot-scope="scope">
                      {{addComma(scope.row.annualCredits)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="requestedCreditIssuance" :label="$t('carbonIndex.mvgxIssuable_cra')">
                    <template slot-scope="scope">
                      <div class="country_txt" @click="changeIssuedetail(scope.row)">{{addComma(scope.row.requestedCreditIssuance)}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="issuableCreditsCheck" :label="$t('carbonIndex.mvgxIssuabledits_cra')">
                    <template slot-scope="scope">
                      {{scope.row.issuableCreditsCheck}}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('carbonIndex.action_Issue')">
                    <template slot-scope="scope">
                      <div class="action_btn" @click="changeIssue(scope.row.id)">{{$t('carbonIndex.action_Credits')}}</div>
                    </template>
                  </el-table-column>

                </el-table>
                <div class="display_flex dis_end" style="margin-top: 47px">
                  <el-pagination
                    v-if="issueList.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="issueList.length"
                  >
                  </el-pagination>
                </div>
                
              </div>
            </div>

            <div class="overview_wrap" v-if="creditssel == 2 && tokenCarbonSel == ''">
                <el-row>
                  <div class="title">
                    {{$t('carbonIndex.Tokenize_Carbon_title')}}
                  </div>
                </el-row>
                <el-row style="margin-bottom:30px">
                  <el-col>
                    <img src="../../assets/img/biao1.png" alt="">
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <div class="Tokenize_title">
                    {{$t('carbonIndex.Tokenize_Carbon_title_National')}}
                  </div>
                </el-row> -->
                <!-- <el-row>
                  <ul>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_National_one')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_National_two')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_National_three')}}
                    </li>
                  </ul>
                </el-row>
                <el-divider></el-divider> -->
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="Tokenize_title">
                      {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized')}}
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="action" @click="action(1)">
                      {{$t('carbonIndex.Action')}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <ul>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized_one')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized_two')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized_three')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized_four')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Tokenized_five')}}
                    </li>
                  </ul>
                </el-row>
                <el-divider></el-divider>
                <el-row type="flex" justify="space-between">
                  <el-col>
                    <div class="Tokenize_title">
                      {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality')}}
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="action"  @click="action(2)">
                      {{$t('carbonIndex.Action')}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <ul>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality_one')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality_two')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality_three')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality_four')}}
                    </li>
                  </ul>
                </el-row>
                <el-divider></el-divider>
                <el-row type="flex" justify="space-between">
                  <el-row >
                    <div class="Tokenize_title">
                      {{$t('carbonIndex.Tokenize_Carbon_title_Carbon_Neutrality_C')}}
                    </div>
                  </el-row>
                  <el-col :span="4">
                    <div class="action" @click="action(3)">
                      {{$t('carbonIndex.Action')}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <ul>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Compliance_Carbon_one')}}
                    </li>
                    <li class="Tokenize_title_item">
                       {{$t('carbonIndex.Compliance_Carbon_two')}}
                    </li>
                  </ul>
                </el-row>
                <el-divider></el-divider>
                <el-row class="owners">
                  <el-col>
                    {{$t('carbonIndex.owners')}}
                    <b>{{$t('carbonIndex.partially_or')}}</b>
                    {{$t('carbonIndex.into_any')}}
                    <b>{{$t('carbonIndex.irreversible')}}</b>
                  </el-col>
                </el-row>
            </div>

            <div class="overview_wrap" v-if="creditssel == 2 && tokenCarbonSel == 1">
                <el-row>
                  <div class="title">
                    <!-- <div class="title_box">
                      <div>{{$t('carbonIndex.project_ID')}}:<span>{{projectId}}</span></div>
                      <div>{{$t('carbonIndex.project_NFDT')}}:<span>{{nfdt}}</span></div>
                    </div> -->
                    <!-- 进度条 -->
                    <div class="steps">
                      <el-steps :active="steps" align-center finish-status="success">
                          <el-step :description="$t('carbonIndex.steps_Proone')"></el-step>
                          <el-step :description="$t('carbonIndex.steps_Protwo')"></el-step>
                          <el-step :description="$t('carbonIndex.steps_Prothree')"></el-step>
                          <el-step :description="$t('carbonIndex.steps_Profour')"></el-step>
                      </el-steps>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <div class="step_box">
                    <!-- 左侧 -->
                    <el-row type="flex" justify="space-between" :gutter="20">
                      <el-col :span="16">
                        <div class="step_text">
                          <!-- 步骤1 -->
                          <div class="text_step" :class="stepnum == 1 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step1')}}</div>
                            <div class="banner_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step_one_txt')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤2 -->
                          <div class="text_step" :class="stepnum == 2 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.step2')}}</div>
                            <div class="banner_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.step_two_txt')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤3 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.step3')}}</div>
                            <div class="banner_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.step_the_txt')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤4 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.step4')}}</div>
                            <div class="banner_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.step_for_txt')}}</div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                        <div style="display:flex">
                          <div class="step_btn" style="width:300px" @click="subMitStepdon()" v-if="stepnum != 1">Documents Upload</div>
                          <div class="step_btn" @click="subMitStep()">Submit</div>
                        </div>
                        
                      </el-col>
                      
                      <!-- 右侧 -->
                      <el-col :span="7">
                        <div class="step_right" >
                          <el-collapse v-if="stepnum == 1" v-model="activeNamestep" accordion>
                            <el-collapse-item :title="$t('carbonIndex.step_pjid')" name="1">
                              <div>
                                <ul class="Country">
                                  <li
                                    :class="projectIdindex == index ? 'overviewSel selbg' : ''"
                                    @click="changeprojectId(index,item)"
                                    v-for="(item, index) in projectIdList"
                                    :key="index"
                                  >
                                    - {{ item }}
                                  </li>
                                </ul>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <div v-if="stepnum == 2">
                            <div class="title_steps">{{$t('carbonIndex.numofcre')}}</div>
                            <el-input v-model="credits"></el-input>
                            <!-- <div class="step_btns" style="max-width:200px">Document Upload</div> -->
                          </div>
                          <div class="banner_box">

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.project_ID')}}:</div>
                              <div class="box_txt">{{carFrom.id ? carFrom.id : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.availableCredits')}}:</div>
                              <div class="box_txt">{{carFrom.credits ? carFrom.credits : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.Project_Name')}}:</div>
                              <div class="box_txt">{{carFrom.projectName ? carFrom.projectName : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.contractAddress')}}:</div>
                              <div class="box_txt">{{carFrom.contractAddress ? carFrom.contractAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.transactionHash')}}:</div>
                              <div class="box_txt">{{carFrom.nftTransactionHash ? carFrom.nftTransactionHash : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.receivedWalletAddress')}}:</div>
                              <div class="box_txt">{{carFrom.receivedWalletAddress ? carFrom.receivedWalletAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>
                            
                          </div>
                        </div>
                      </el-col>
                      
                    </el-row>
                  </div>

                  <!-- <div class="step_btn" @click="subMitStep()">Submit</div> -->
                  <!-- <div class="step_btn" v-if="stepnum != 2 && submitbool" @click="changesteps()">Next</div> -->
                </el-row>
            </div>
            <div class="overview_wrap" v-if="creditssel == 2 && tokenCarbonSel == 2">
                <el-row>
                  <div class="title">
                    <!-- <div class="title_box">
                      <div>{{$t('carbonIndex.project_ID')}}:<span>{{projectId}}</span></div>
                      <div>{{$t('carbonIndex.project_NFDT')}}:<span>{{nfdt}}</span></div>
                    </div> -->
                    <!-- 进度条 -->
                    <div class="steps">
                      <el-steps :active="steps" align-center finish-status="success">
                          <el-step :description="$t('carbonIndex.projectSelection')"></el-step>
                          <el-step :description="$t('carbonIndex.ssuanceApplication')"></el-step>
                          <el-step :description="$t('carbonIndex.creditFreeze')"></el-step>
                          <el-step :description="$t('carbonIndex.cntDocument')"></el-step>
                          <el-step :description="$t('carbonIndex.cntLssuan')"></el-step>
                          <el-step :description="$t('carbonIndex.cntonMvgx')"></el-step>
                      </el-steps>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <!-- 表格 -->
                  <!-- <div >
                    <el-table
                      :data="projectArr" stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      :cell-style="columnStyle"
                      style="width: 100%"
                    >
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">No Data</p>
                      </template>
                      <el-table-column prop="id"  :label="$t('carbonIndex.project_ID')">
                      </el-table-column>
                      <el-table-column prop="nftTransactionHash"  :label="$t('carbonIndex.projectNFDT')">
                      </el-table-column>
                      <el-table-column prop="projectName" :label="$t('carbonIndex.project_NAME')">
                      </el-table-column>
                      <el-table-column prop="credits" :label="$t('carbonIndex.creditsFrozen')">
                      </el-table-column>
                      <el-table-column :label="$t('carbonIndex.acsuff')">
                        <template>
                          <div>Yes</div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="credits" :label="$t('carbonIndex.rcafreeze')">
                      </el-table-column>
                      <el-table-column prop="projectId" :label="$t('carbonIndex.documentSubmit')">
                        <template>
                          <div>Yes(<span style="color:#158869;cursor: pointer;">View</span>)</div>
                        </template>
                      </el-table-column>

                    </el-table>
                    <div class="btn_box_flex">
                     
                      <div class="step_btns">Freeze Credits</div>
                      <div class="step_btns">Request More Info</div>
                      <div class="step_btns">Issue Certificate</div>
                    </div>
                  </div> -->
                  <!-- 步骤 -->
                  <div class="step_box" style="margin-top:20px">
                    <el-row type="flex" justify="space-between" :gutter="20">
                      <!-- 左侧 -->
                      <el-col :span="16">
                        <div class="step_text">
                          <!-- 步骤1 -->
                          <div class="text_step" :class="stepnum == 1 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step1')}}</div>
                            <div class="banner_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.stepone_banner')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤2 -->
                          <div class="text_step" :class="stepnum == 2 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.step2')}}</div>
                            <div class="banner_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.steptwo_banner')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤3 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.step3')}}</div>
                            <div class="banner_step" :class="stepnum3 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepthe_banner_two')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">View Certificate</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤4 -->
                          <div class="text_step" >
                            <div class="title_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.step4')}}</div>
                            <div class="banner_step" :class="stepnum4 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfor_banner')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">View Listing Docs</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤5 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum5 ? 'color_title' : ''">{{$t('carbonIndex.step5')}}</div>
                            <div class="banner_step" :class="stepnum5 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfiv_banner')}}
                              <div class="step_btns btn_box_left"  v-if="stepproject">View CNTs</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤6 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum6 ? 'color_title' : ''">{{$t('carbonIndex.step6')}}</div>
                            <div class="banner_step" :class="stepnum6 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfix_banner')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">Visit MVGX Trading Platform</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                        <div style="display:flex">
                          <div class="step_btn" style="width:300px" @click="subMitStepdon()" v-if="stepnum != 1">Documents Upload</div>
                          <div class="step_btn" @click="subMitStep()">Submit</div>
                        </div>
                      </el-col>
                      
                      <!-- 右侧 -->
                      <el-col :span="7">
                        <div class="step_right">
                          <el-collapse v-if="stepnum == 1" v-model="activeNamestep" accordion>
                            <el-collapse-item :title="$t('carbonIndex.step_pjid')" name="1">
                              <div>
                                <ul class="Country">
                                  <li
                                    :class="projectIdindex == index ? 'overviewSel selbg' : ''"
                                    @click="changeprojectId(index,item)"
                                    v-for="(item, index) in projectIdList"
                                    :key="index"
                                  >
                                    - {{ item }}
                                  </li>
                                </ul>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <div v-if="stepnum == 2">
                            <div class="title_steps">{{$t('carbonIndex.numofcre')}}</div>
                            <el-input v-model="credits"></el-input>
                            <!-- <div class="step_btns" style="max-width:200px">Document Upload</div> -->
                          </div>
                          <div class="banner_box">

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.project_ID')}}:</div>
                              <div class="box_txt">{{carFrom.id ? carFrom.id : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.availableCredits')}}:</div>
                              <div class="box_txt">{{carFrom.credits ? carFrom.credits : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.Project_Name')}}:</div>
                              <div class="box_txt">{{carFrom.projectName ? carFrom.projectName : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.contractAddress')}}:</div>
                              <div class="box_txt">{{carFrom.contractAddress ? carFrom.contractAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.transactionHash')}}:</div>
                              <div class="box_txt">{{carFrom.nftTransactionHash ? carFrom.nftTransactionHash : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.receivedWalletAddress')}}:</div>
                              <div class="box_txt">{{carFrom.receivedWalletAddress ? carFrom.receivedWalletAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>
                            
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  

                  <!-- <div class="step_btn" v-if="stepnum == 3 && submitbool" @click="subMitStep()">Submit</div> -->
                  <!-- <div class="step_btn" v-if="stepnum != 3 && submitbool" @click="changestepstwo()">Next</div> -->
                </el-row>
            </div>

            <div class="overview_wrap" v-if="creditssel == 2 && tokenCarbonSel == 3">
                <el-row>
                  <div class="title">
                    <!-- <div class="title_box">
                      <div>{{$t('carbonIndex.project_ID')}}:<span>{{projectId}}</span></div>
                      <div>{{$t('carbonIndex.project_NFDT')}}:<span>{{nfdt}}</span></div>
                    </div> -->
                    <!-- 进度条 -->
                    <div class="steps">
                      <el-steps :active="steps" align-center finish-status="success">
                          <el-step :description="$t('carbonIndex.projectSelection')"></el-step>
                          <el-step :description="$t('carbonIndex.ssuanceApplication_c')"></el-step>
                          <el-step :description="$t('carbonIndex.creditFreeze_c')"></el-step>
                          <el-step :description="$t('carbonIndex.cntDocument_c')"></el-step>
                          <el-step :description="$t('carbonIndex.cntLssuan_c')"></el-step>
                          <el-step :description="$t('carbonIndex.cntonMvgx_c')"></el-step>
                          <el-step :description="$t('carbonIndex.cntonad_c')"></el-step>
                      </el-steps>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <div class="step_box">
                    <el-row type="flex" justify="space-between" :gutter="20">
                      <!-- 左侧 -->
                      <el-col :span="16">
                        <div class="step_text">
                          <!-- 步骤1 -->
                          <div class="text_step" :class="stepnum == 1 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step1')}}</div>
                            <div class="banner_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.stepone_banner')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤2 -->
                          <div class="text_step" :class="stepnum == 2 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.step2')}}</div>
                            <div class="banner_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.steptwo_banner_c')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤3 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.step3')}}</div>
                            <div class="banner_step" :class="stepnum3 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepthe_banner')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">View Certificate</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤4 -->
                          <div class="text_step" >
                            <div class="title_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.step4')}}</div>
                            <div class="banner_step" :class="stepnum4 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfor_banner_c')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">View Listing Docs</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤5 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum5 ? 'color_title' : ''">{{$t('carbonIndex.step5')}}</div>
                            <div class="banner_step" :class="stepnum5 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfiv_banner_c')}}
                              <div class="step_btns btn_box_left"  v-if="stepproject">View CNTs</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤6 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum6 ? 'color_title' : ''">{{$t('carbonIndex.step6')}}</div>
                            <div class="banner_step" :class="stepnum6 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepfix_banner_c')}}
                              <div class="step_btns btn_box_left" v-if="stepproject">Visit MVGX Trading Platform</div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤7 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum7 ? 'color_title' : ''">{{$t('carbonIndex.step7')}}</div>
                            <div class="banner_step" :class="stepnum7 ? 'color_title' : ''">
                              {{$t('carbonIndex.stepsen_banner_c')}}
                              <!-- <div class="step_btns btn_box_left" v-if="stepproject">Visit MVGX Trading Platform</div> -->
                            </div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                        <div style="display:flex">
                          <div class="step_btn" style="width:300px" @click="subMitStepdon()" v-if="stepnum != 1">Documents Upload</div>
                          <div class="step_btn" @click="subMitStep()">Submit</div>
                        </div>
                      </el-col>

                      <!-- 右侧 -->
                      <el-col :span="7">
                        <div class="step_right">
                          <el-collapse v-if="stepnum == 1" v-model="activeNamestep" accordion>
                            <el-collapse-item :title="$t('carbonIndex.step_pjid')" name="1">
                              <div>
                                <ul class="Country">
                                  <li
                                    :class="projectIdindex == index ? 'overviewSel selbg' : ''"
                                    @click="changeprojectId(index,item)"
                                    v-for="(item, index) in projectIdList"
                                    :key="index"
                                  >
                                    - {{ item }}
                                  </li>
                                </ul>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <div v-if="stepnum == 2">
                            <div class="title_steps">{{$t('carbonIndex.numofcre')}}</div>
                            <el-input v-model="credits"></el-input>
                            <!-- <div class="step_btns" style="max-width:200px">Document Upload</div> -->
                          </div>
                          <div class="banner_box">

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.project_ID')}}:</div>
                              <div class="box_txt">{{carFrom.id ? carFrom.id : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.availableCredits')}}:</div>
                              <div class="box_txt">{{carFrom.credits ? carFrom.credits : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.Project_Name')}}:</div>
                              <div class="box_txt">{{carFrom.projectName ? carFrom.projectName : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.contractAddress')}}:</div>
                              <div class="box_txt">{{carFrom.contractAddress ? carFrom.contractAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.transactionHash')}}:</div>
                              <div class="box_txt">{{carFrom.nftTransactionHash ? carFrom.nftTransactionHash : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.receivedWalletAddress')}}:</div>
                              <div class="box_txt">{{carFrom.receivedWalletAddress ? carFrom.receivedWalletAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>
                            
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- <div class="step_btn" v-if="stepnum == 3 && submitbool" @click="subMitStep()">Submit</div> -->
                  <!-- <div class="step_btn" v-if="stepnum != 3 && submitbool" @click="changestepstwo()">Next</div> -->
                </el-row>
            </div>

            <div class="overview_wrap" v-if="creditssel == 5">
                <el-row>
                  <div class="title">
                    <div class="steps">
                      <el-steps :active="steps" align-center finish-status="success">
                          <el-step :description="$t('carbonIndex.steps_Proone')"></el-step>
                          <el-step :description="$t('carbonIndex.CancellationRequest')"></el-step>
                          <el-step :description="$t('carbonIndex.CreditCancellation')"></el-step>
                          <el-step :description="$t('carbonIndex.CancellationCertificate')"></el-step>
                      </el-steps>
                    </div>
                  </div>
                </el-row>
                <el-row>
                  <div class="step_box">
                    <!-- 左侧 -->
                    <el-row type="flex" justify="space-between" :gutter="20">
                      <el-col :span="16">
                        <div class="step_text">
                          <!-- 步骤1 -->
                          <div class="text_step" :class="stepnum == 1 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step1')}}</div>
                            <div class="banner_step" :class="stepnum1 ? 'color_title' : ''">{{$t('carbonIndex.step_one_txt')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤2 -->
                          <div class="text_step" :class="stepnum == 2 ? 'color_txt' : ''">
                            <div class="title_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.step2')}}</div>
                            <div class="banner_step" :class="stepnum2 ? 'color_title' : ''">{{$t('carbonIndex.CancellProjectOwner')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤3 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.step3')}}</div>
                            <div class="banner_step" :class="stepnum3 ? 'color_title' : ''">{{$t('carbonIndex.CancellRegistry')}}</div>
                            <el-divider></el-divider>
                          </div>
                          <!-- 步骤4 -->
                          <div class="text_step">
                            <div class="title_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.step4')}}</div>
                            <div class="banner_step" :class="stepnum4 ? 'color_title' : ''">{{$t('carbonIndex.CancellRegistryIssues')}}</div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                        <div style="display:flex">
                          <div class="step_btn" style="width:300px" @click="subMitStepdon()" v-if="stepnum != 1">Documents Upload</div>
                          <div class="step_btn" @click="subMitStep()">Submit</div>
                        </div>
                        
                      </el-col>
                      
                      <!-- 右侧 -->
                      <el-col :span="7">
                        <div class="step_right" >
                          <el-collapse v-if="stepnum == 1" v-model="activeNamestep" accordion>
                            <el-collapse-item :title="$t('carbonIndex.step_pjid')" name="1">
                              <div>
                                <ul class="Country">
                                  <li
                                    :class="projectIdindex == index ? 'overviewSel selbg' : ''"
                                    @click="changeprojectId(index,item)"
                                    v-for="(item, index) in projectIdList"
                                    :key="index"
                                  >
                                    - {{ item }}
                                  </li>
                                </ul>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <div v-if="stepnum == 2">
                            <div class="title_steps">{{$t('carbonIndex.numofcre')}}</div>
                            <el-input v-model="credits"></el-input>
                            <!-- <div class="step_btns" style="max-width:200px">Document Upload</div> -->
                          </div>
                          <div class="banner_box">

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.project_ID')}}:</div>
                              <div class="box_txt">{{carFrom.id ? carFrom.id : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.availableCredits')}}:</div>
                              <div class="box_txt">{{carFrom.credits ? carFrom.credits : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.Project_Name')}}:</div>
                              <div class="box_txt">{{carFrom.projectName ? carFrom.projectName : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.contractAddress')}}:</div>
                              <div class="box_txt">{{carFrom.contractAddress ? carFrom.contractAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.transactionHash')}}:</div>
                              <div class="box_txt">{{carFrom.nftTransactionHash ? carFrom.nftTransactionHash : '--'}}</div>
                              <el-divider></el-divider>
                            </div>

                            <div class="box_box">
                              <div class="box_tit">{{$t('carbonIndex.receivedWalletAddress')}}:</div>
                              <div class="box_txt">{{carFrom.receivedWalletAddress ? carFrom.receivedWalletAddress : '--'}}</div>
                              <el-divider></el-divider>
                            </div>
                            
                          </div>
                        </div>
                      </el-col>
                      
                    </el-row>
                  </div>

                  <!-- <div class="step_btn" @click="subMitStep()">Submit</div> -->
                  <!-- <div class="step_btn" v-if="stepnum != 2 && submitbool" @click="changesteps()">Next</div> -->
                </el-row>
            </div>

            <!-- table表格 -->
            <div v-if="creditssel == 4">
              <div class="top1" v-if="login.groupId">
                <div class="cf_h3">Total Credits Issued: <span class="cf_title">{{addComma(this.t1)}}</span></div>
                <div class="cf_h3">Tokenized Credits:  <span class="cf_title">{{addComma(this.t2)}}</span></div>
                <div class="cf_h3">C-CNTs: <span class="cf_title">{{addComma(this.t3)}}</span></div>
              </div>
              <el-table
                :data="
                  tableData.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                  )
                "
                stripe
                :header-cell-style="{
                  background: '#F0F3F6',
                  color: '#626262',
                  fontSize: '14px',
                  fontFamily: 'ArialMT',
                  paddingTop: '17px',
                  paddingBottom: '15px',
                  paddingLeft:'20px'
                }"
                :cell-style="columnStyle"
                @row-click="getDetail"
                style="width: 100%"
              >
                <!-- 空状态 -->
                <template slot="empty">
                  <p style="margin-top: 50px">
                    <img
                      class="data-pic"
                      src="../../assets/img/noData.png"
                      alt=""
                    />
                  </p>
                  <p class="nodata">{{ $t("carbonIndex.noData") }}</p>
                </template>
                <el-table-column prop="id" width="80px" :label="$t('carbonIndex.ID')">
                </el-table-column>
                <el-table-column prop="name" width="200px" :label="$t('carbonIndex.Name')">
                </el-table-column>
                <el-table-column
                  prop="country"
                  :label="$t('carbonIndex.Country')"
                  v-if="login.type == 1  || login.groupId"
                >
                </el-table-column>
                <el-table-column
                  prop="state"
                  :label="$t('carbonIndex.province')"
                  v-if="login.type == 2"
                >
                </el-table-column>
                
                <el-table-column
                  prop="quantity"
                  :label="$t('carbonIndex.Quantity')"
                >
                  <template slot-scope="scope">
                    {{addComma(scope.row.quantity)}}
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  prop="issued"
                  :label="$t('carbonIndex.Date_Issued')"
                  
                >
                  <template slot-scope="scope">
                    {{ scope.row.issued ? formatDate(scope.row.issued) : '--'}}
                  </template>
                </el-table-column> -->
                <el-table-column
                  width="200px"
                  prop="creditingPeriod"
                  :label="$t('carbonIndex.cpiod')"
                >
                <template slot-scope="scope">
                    {{  scope.row.creditingPeriod ?  scope.row.creditingPeriod : '--'}}
                  </template>
                </el-table-column>

              </el-table>
              <div class="display_flex dis_end" style="margin-top: 47px">
                <el-pagination
                  v-if="tableData.length != 0"
                  @current-change="handleCurrentChange"
                  :page-size="pageSize"
                  background
                  layout="prev, pager, next"
                  class="pagination"
                  prev-text="<"
                  next-text=">"
                  :total="tableData.length"
                >
                </el-pagination>
              </div>
            </div>



            <div class="" v-if="creditssel == 3">
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Projects_with") }}
                  </div>
                </el-row>
                <el-table
                  :data=" mamageProjectList_Manage"
                  stripe
                  :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '14px',
                    fontFamily: 'ArialMT',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    paddingLeft:'20px'
                  }"
                  style="width: 910px;max-width:910px"
                  :cell-style="columnStyle"
                  
                >
                  <!-- 空状态  @row-click="getDetail"-->
                  <template slot="empty">
                    <p style="margin-top: 50px">
                      <img
                        class="data-pic"
                        src="../../assets/img/noData.png"
                        alt=""
                      />
                    </p>
                    <p class="nodata">No Data</p>
                  </template>
                  <el-table-column prop="requestDate" width="150" :label="$t('carbonIndex.RequestDate')">
                    <template slot-scope="scope">
                      {{formatDate(scope.row.requestDate)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="approvalRequested" width="250" :label="$t('carbonIndex.ActionRequested_Manage')">
                  </el-table-column>
                  <el-table-column prop="projectId" width="150" :label="$t('carbonIndex.projectId')">
                  </el-table-column>
                  <el-table-column prop="projectName" width="250" :label="$t('carbonIndex.manProjectName')">
                  </el-table-column>
                  <el-table-column prop="projectDeveloper" width="150" :label="$t('carbonIndex.projectProponent')">
                  </el-table-column>
                  <el-table-column prop="projectVerifier" width="150" :label="$t('carbonIndex.projectvvb')">
                  </el-table-column>
                  <el-table-column prop="annualCredits" width="150" :label="$t('carbonIndex.Number_of_Credits')">
                    <template slot-scope="scope">
                      {{addComma(scope.row.annualCredits)}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="documentsSubmitted" width="250" :label="$t('carbonIndex.DocumentsSubmitted')">
                  </el-table-column>
                   <el-table-column prop="nftTransactionHashView" width="250" :label="$t('carbonIndex.manProjectAddress')">
                    <template  slot-scope="scope">
                      <span style="color:#158869;">
                        <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/tx/' + scope.row.nftTransactionHash" >{{scope.row.nftTransactionHashView}}</a>
                      </span>
                    </template>
                  </el-table-column> 
                  <el-table-column
                    prop="projectStatus"
                    fixed="right"
                    width="150"
                    :label="$t('carbonIndex.TakeAction')">
                    <template >
                      <div style="margin:0 auto">
                        <div class="request_btn">{{$t('carbonIndex.Request_more_Info')}}</div>
                        <div class="request_btn btn_green">{{$t('carbonIndex.Approve')}}</div>
                        <div class="request_btn btn_orage">{{$t('carbonIndex.Decline')}}</div>
                      </div>
                      
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="display_flex dis_end" style="margin-top: 47px">
                  <el-pagination
                    v-if="projectsIntroducedList.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="projectsIntroducedList.length"
                  >
                  </el-pagination>
                </div> -->
              </div>
            </div>
          </div>

          <div v-if="currentActiveName == 4">
              <div class="overview_wrap" v-if="transactionsSel == 1">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Projects_with_Issued_title") }}
                  </div>
                </el-row>

                <el-table
                    :data="
                      ConbonList.slice(
                        (currentPage - 1) * pageSize,
                        currentPage * pageSize
                      )
                    "
                    stripe
                    :header-cell-style="{
                      background: '#F0F3F6',
                      color: '#626262',
                      fontSize: '14px',
                      fontFamily: 'ArialMT',
                      paddingTop: '17px',
                      paddingBottom: '15px',
                      paddingLeft:'20px'
                    }"
                    :cell-style="columnStyle"
                    style="width: 100%"
                  >
                    <!-- 空状态 -->
                    <template slot="empty">
                      <p style="margin-top: 50px">
                        <img
                          class="data-pic"
                          src="../../assets/img/noData.png"
                          alt=""
                        />
                      </p>
                      <p class="nodata">No Data</p>
                    </template>
                    <el-table-column prop="date"  :label="$t('carbonIndex.DateTime')">
                    </el-table-column>
                    <el-table-column prop="BuyerId"  :label="$t('carbonIndex.Buyer')">
                    </el-table-column>
                    <el-table-column
                      prop="sellId"
                      :label="$t('carbonIndex.Sell')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="type"
                      :label="$t('carbonIndex.typeOf')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="Transaction"
                      :label="$t('carbonIndex.Transaction')"
                    >
                    </el-table-column>
                </el-table>
                  <!-- <div class="display_flex dis_end" style="margin-top: 47px">
                    <el-pagination
                      v-if="tableData.length != 0"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      background
                      layout="prev, pager, next"
                      class="pagination"
                      prev-text="<"
                      next-text=">"
                      :total="tableData.length"
                    >
                    </el-pagination>
                  </div> -->
              </div>
              <div class="overview_wrap" v-if="transactionsSel == 2">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Domestic_Transaction") }}
                  </div>
                </el-row>

                <el-table
                    :data="
                      nfConbonList.slice(
                        (currentPage - 1) * pageSize,
                        currentPage * pageSize
                      )
                    "
                    stripe
                    :header-cell-style="{
                      background: '#F0F3F6',
                      color: '#626262',
                      fontSize: '14px',
                      fontFamily: 'ArialMT',
                      paddingTop: '17px',
                      paddingBottom: '15px',
                      paddingLeft:'20px'
                    }"
                    :cell-style="columnStyle"
                    style="width: 100%"
                  >
                    <!-- 空状态 -->
                    <template slot="empty">
                      <p style="margin-top: 50px">
                        <img
                          class="data-pic"
                          src="../../assets/img/noData.png"
                          alt=""
                        />
                      </p>
                      <p class="nodata">No Data</p>
                    </template>
                    <el-table-column prop="date"  :label="$t('carbonIndex.DateTime')">
                    </el-table-column>
                    <el-table-column prop="BuyerId"  :label="$t('carbonIndex.Buyer')">
                    </el-table-column>
                    <el-table-column
                      prop="sellId"
                      :label="$t('carbonIndex.Sell')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="type"
                      :label="$t('carbonIndex.typeOf')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="Transaction"
                      :label="$t('carbonIndex.Transaction')"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="projectId"
                      :label="$t('carbonIndex.NFDT_Address')"
                    >
                      <template  slot-scope="scope">
                        <span style="color:#158869;">
                          <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/tx/' + '0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a'" >{{scope.row.projectId}}</a>
                        </span>
                      </template>
                    </el-table-column>

                  </el-table>
                  <!-- <div class="display_flex dis_end" style="margin-top: 47px">
                    <el-pagination
                      v-if="tableData.length != 0"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      background
                      layout="prev, pager, next"
                      class="pagination"
                      prev-text="<"
                      next-text=">"
                      :total="tableData.length"
                    >
                    </el-pagination>
                  </div> -->
              </div>

              <div class="overview_wrap" v-if="transactionsSel == 3 && MakeCarbonSel == 1">
                <el-row>
                  <div class="title_TEXT">
                    {{ $t("carbonIndex.Projects_with_Issued_title_TXT") }}
                  </div>
                  <div class="title_TEXT">
                    {{ $t("carbonIndex.Projects_with_Issued_title_TXT1") }}
                  </div>
                </el-row>
              </div>

              <div class="overview_wrap" v-if="transactionsSel == 3 && MakeCarbonSel == 2">
                <el-row>
                  <el-row>
                    <div class="title">
                      {{ $t("carbonIndex.CorrespondingAdjustments") }}
                    </div>
                  </el-row>
                  
                  <div class="" v-if="login.groupId == 2">
                    <el-table
                      :data="ProjectList_Carbon_ASEAN"
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      style="width: 910px;max-width:910px"
                      :cell-style="columnStyle"
                    >
                      <!-- 空状态 -->
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">No Data</p>
                      </template>
                      <el-table-column prop="date" width="200" :label="$t('carbonIndex.TransactionDateandTime')">
                      </el-table-column>
                      <el-table-column prop="buyerId" width="150" :label="$t('carbonIndex.BuyerID')">
                      </el-table-column>
                      <el-table-column prop="buyerCountry" width="150" :label="$t('carbonIndex.BuyerCountry')">
                      </el-table-column>
                      <el-table-column prop="sellerID" width="150" :label="$t('carbonIndex.SellerID')">
                      </el-table-column>
                      <el-table-column prop="sellerCountry" width="150" :label="$t('carbonIndex.SellerCountry')">
                      </el-table-column>
                      <el-table-column prop="typeofCredits" width="150" :label="$t('carbonIndex.TypeofCredits')">
                      </el-table-column>
                      <el-table-column prop="transaction" width="150" :label="$t('carbonIndex.TransactionQuantity')">
                        <template slot-scope="scope">
                          {{addComma(scope.row.transaction)}}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="nfdtAddress"
                        width="250"
                        :label="$t('carbonIndex.TransactionNFDTNodeAddress')">
                          <template  slot-scope="scope">
                            <span style="color:#158869;">
                              <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/tx/' + '0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a'" >{{scope.row.nfdtAddress}}</a>
                            </span>
                          </template>
                      </el-table-column> 
                      <el-table-column
                        prop="projectStatus"
                        fixed="right"
                        width="150"
                        :label="$t('carbonIndex.CAApproved')">
                        <template slot-scope="scope">
                          <div class="carbon_btn_box_box">
                            <div :class="scope.row.isclick ? 'disabled_cabon carbon_btn_box' : 'carbon_btn_box bg_btn_box'" @click="successSubmit(scope.row,scope.$index)">Yes</div>
                            <!-- <div style="margin-top:20px;margin-left:0" class="carbon_btn_box" @click.stop="errSubmit(scope.row,scope.$index)">No</div> -->
                            <div :class="scope.row.isclick ? 'disabled_cabon_border carbon_btn_box' : 'carbon_btn_box'" style="margin-top:20px;margin-left:0" @click.stop="errSubmit(scope.row,scope.$index)">No</div>
                          </div>
                          
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="" v-else-if="login.groupId == 3">
                    <el-table
                      :data="ProjectList_Carbon_ASEAN_China"
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      style="width: 910px;max-width:910px"
                      :cell-style="columnStyle"
                    >
                      <!-- 空状态 -->
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">No Data</p>
                      </template>
                      <el-table-column prop="date" width="200" :label="$t('carbonIndex.TransactionDateandTime')">
                      </el-table-column>
                      <el-table-column prop="buyerId" width="150" :label="$t('carbonIndex.BuyerID')">
                      </el-table-column>
                      <el-table-column prop="buyerCountry" width="150" :label="$t('carbonIndex.BuyerCountry')">
                      </el-table-column>
                      <el-table-column prop="sellerID" width="150" :label="$t('carbonIndex.SellerID')">
                      </el-table-column>
                      <el-table-column prop="sellerCountry" width="150" :label="$t('carbonIndex.SellerCountry')">
                      </el-table-column>
                      <el-table-column prop="typeofCredits" width="150" :label="$t('carbonIndex.TypeofCredits')">
                      </el-table-column>
                      <el-table-column prop="transaction" width="150" :label="$t('carbonIndex.TransactionQuantity')">
                        <template slot-scope="scope">
                          {{addComma(scope.row.transaction)}}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="nfdtAddress"
                        width="250"
                        :label="$t('carbonIndex.TransactionNFDTNodeAddress')">
                          <template  slot-scope="scope">
                            <span style="color:#158869;">
                              <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/tx/' + '0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a'" >{{scope.row.nfdtAddress}}</a>
                            </span>
                          </template>
                      </el-table-column> 
                      <el-table-column
                        prop="projectStatus"
                        fixed="right"
                        width="150"
                        :label="$t('carbonIndex.CAApproved')">
                        <template slot-scope="scope">
                          <div class="carbon_btn_box_box">
                            <div :class="scope.row.isclick ? 'disabled_cabon carbon_btn_box' : 'carbon_btn_box bg_btn_box'" @click="successSubmit(scope.row,scope.$index)">Yes</div>
                            <!-- <div style="margin-top:20px;margin-left:0" class="carbon_btn_box" @click.stop="errSubmit(scope.row,scope.$index)">No</div> -->
                            <div :class="scope.row.isclick ? 'disabled_cabon_border carbon_btn_box' : 'carbon_btn_box'" style="margin-top:20px;margin-left:0" @click.stop="errSubmit(scope.row,scope.$index)">No</div>
                          </div>
                          
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="" v-else>
                    <el-table
                      :data="ProjectList_Carbon"
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      style="width: 910px;max-width:910px"
                      :cell-style="columnStyle"
                    >
                      <!-- 空状态 -->
                      <template slot="empty">
                        <p style="margin-top: 50px">
                          <img
                            class="data-pic"
                            src="../../assets/img/noData.png"
                            alt=""
                          />
                        </p>
                        <p class="nodata">No Data</p>
                      </template>
                      <el-table-column prop="date" width="200" :label="$t('carbonIndex.TransactionDateandTime')">
                      </el-table-column>
                      <el-table-column prop="buyerId" width="150" :label="$t('carbonIndex.BuyerID')">
                      </el-table-column>
                      <el-table-column prop="buyerCountry" width="150" :label="$t('carbonIndex.BuyerCountry')">
                      </el-table-column>
                      <el-table-column prop="sellerID" width="150" :label="$t('carbonIndex.SellerID')">
                      </el-table-column>
                      <el-table-column prop="sellerCountry" width="150" :label="$t('carbonIndex.SellerCountry')">
                      </el-table-column>
                      <el-table-column prop="typeofCredits" width="150" :label="$t('carbonIndex.TypeofCredits')">
                      </el-table-column>
                      <el-table-column prop="transaction" width="150" :label="$t('carbonIndex.TransactionQuantity')">
                        <template slot-scope="scope">
                          {{addComma(scope.row.transaction)}}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="nfdtAddress"
                        width="250"
                        :label="$t('carbonIndex.TransactionNFDTNodeAddress')">
                          <template  slot-scope="scope">
                            <span style="color:#158869;">
                              <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/tx/' + '0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a'" >{{scope.row.nfdtAddress}}</a>
                            </span>
                          </template>
                      </el-table-column> 
                      <el-table-column
                        prop="projectStatus"
                        fixed="right"
                        width="150"
                        :label="$t('carbonIndex.CAApproved')">
                        <template slot-scope="scope">
                          <div class="carbon_btn_box_box">
                            <div :class="scope.row.isclick ? 'disabled_cabon carbon_btn_box' : 'carbon_btn_box bg_btn_box'" @click="successSubmit(scope.row,scope.$index)">Yes</div>
                            <!-- <div style="margin-top:20px;margin-left:0" class="carbon_btn_box" @click.stop="errSubmit(scope.row,scope.$index)">No</div> -->
                            <div :class="scope.row.isclick ? 'disabled_cabon_border carbon_btn_box' : 'carbon_btn_box'" style="margin-top:20px;margin-left:0" @click.stop="errSubmit(scope.row,scope.$index)">No</div>
                          </div>
                          
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                 
                </el-row>
              </div>
          </div>


          <!-- NEA -->
          <div v-if="currentActiveName == 6">
              <div class="overview_wrap" v-if="carbonCreditIndex == 1">
                <Carbon0/>
              </div>
              <div class="overview_wrap" v-if="carbonCreditIndex == 2">
                <Carbon1/>
              </div>
              <div class="overview_wrap" v-if="carbonCreditIndex == 3">
                <Carbon2/>
              </div>
          </div>

          <!-- NEA -->
          <div v-if="currentActiveName == 7">
              <div class="overview_wrap" v-if="carbonTransferIndex == 1">
                <CarbonTransfer0/>
              </div>
              <div class="overview_wrap" v-if="carbonTransferIndex == 2">
                <CarbonTransfer1/>
              </div>
              <div class="overview_wrap" v-if="carbonTransferIndex == 3">
                <CarbonTransfer2/>
              </div>
          </div>

          <!-- NEA -->
          <div v-if="currentActiveName == 8">
              <div class="overview_wrap">
                  <SystemLog/>
              </div>
          </div>


          <!-- <div class="overview_wrap" v-if="currentActiveName == 4 && transactionsSel == 3">
            <el-row>
              <div class="title_TEXT">
                {{ $t("carbonIndex.Projects_with_Issued_title_TXT") }}
              </div>
            </el-row>
          </div> -->


        </el-col>
      </el-row>


      <!-- Carbon Footprint -->
      <el-row type="flex" v-if="index == 2" :gutter="20" justify="space-between">
        <!-- 左侧 -->
        <el-col :span="10" class="left">
          
          <el-collapse v-model="activeName_CF" @change="handleChangeCF" accordion>
            <el-collapse-item :class="{ aaa: activeName_CF == 1 }" title="Carbon Footprint Project Selection" name="1">
              <div class="Tokenize">
                <el-collapse v-model="selection_Name" @change="handleChangeProjectCF" accordion class="one">
                  <!-- <el-collapse-item title="- project overview" name="1">
                  </el-collapse-item> -->
                  <el-collapse-item title="- Carbon Footprint Reporting and Certification" name="2">
                  </el-collapse-item>
                  <el-collapse-item title="- Carbon Footprint Reporting Only" name="3">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 2 }" title="Carbon Emission Calculator" name="2">
              <div class="Tokenize">
                <el-collapse v-model="selection_Name" @change="handleChangeProjectCF" accordion class="one">
                  <el-collapse-item title="- Activity Data Entry" name="1">
                  </el-collapse-item>
                  <el-collapse-item title="- Display Quantified Emissions" name="2">
                  </el-collapse-item>
                  <el-collapse-item title="- Establish External Data Connection" name="3">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 3 }" title="Generate Reports and Submit for Certification" name="3">
              <div class="Tokenize">
                <el-collapse v-model="selection_Name" @change="handleChangeProjectCF" accordion class="one">
                  <el-collapse-item title="- Generate and Review Reports" name="1">
                  </el-collapse-item>
                  <el-collapse-item title="- Submit Reports & Documents for Verification" name="2">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 4 }" title="Carbon Footprint Verification by Certification Agency" name="4">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 5 }" title="Certificate and NFT Issuance" name="5">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 6 }" title="Engage a Carbon Service Provider" name="6">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CF == 7 }" title="Emission Factors Database Maintenance" name="7">
            </el-collapse-item>
          </el-collapse>
          
          <!-- <div class="logOut">{{$t('carbonIndex.logOUt')}}</div> -->
        </el-col>

        <!-- 右侧 -->
        <el-col>
            <!-- <div v-if="activeName_CF == ''">
              <div
              class="threeWrap"
              v-if="active  == null"
            >
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    {{ $t("carbonIndex.Registered_Carbon_Projects") }}<span v-if="login.groupId == 3"> {{'(China + Singapore)'}}</span><span v-if="login.groupId == 2"> {{'(ASEAN)'}}</span>
                  </div>
                </el-row>
                <el-row>
                  <div class="map_box" id="maps">
                    <MAPS/>
                  </div>
                </el-row>
                <el-row type="flex" justify="space-between" class="one" style="margin-top:30px">
                  <el-col class="name"><span v-if="login.groupId"> 
                    </span>
                  China Carbon Footprint Projects</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">3</el-col>
                </el-row>
                <el-row type="flex" justify="space-between" class="one">
                  <el-col class="name"><span v-if="login.groupId"></span>
                  Singapore Carbon Footprint Projects</el-col>
                  <el-col class="nums" style="text-align:left" :span="6">5</el-col>
                </el-row>

              </div>

             
            </div>
            </div> -->

            <div v-if="activeName_CF == 1">
              <div class="overview_wrap cf_box">

                <div v-if="selection_Name == 3">
                  <div>
                    <div class="s_txt mg">Carbon Footprint for </div>
                    <div class="radio mgr">
                      <el-radio v-model="radiofoott2" label="1">Reporting Only</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="radiofoott2" disabled label="2">Reporting and ISO certification</el-radio>
                    </div>
                    <el-divider></el-divider>
                    <div v-if="radiofoott2 == '2'" class="mgr">
                      <div class="s_txt mg">Certification Agency Selection </div>
                      <div class="radio mgr">
                        <el-radio v-model="radiofoottype" label="1">British Standards Institution (BSI)</el-radio>
                      </div>
                      <div class="radio">
                        <el-radio v-model="radiofoottype" label="2">TÜV SÜD</el-radio>
                      </div>
                    </div>
                    <div class="s_txt mg">Project Type Selection</div>
                    <div class="radio mgr">
                      <el-radio v-model="radioTypeonly" label="1">Organization Level (ISO 14064-1)</el-radio>
                    </div>
                    <div class="radio mgr">
                      <el-radio v-model="radioTypeonly" label="2">Project Level (ISO 14064-2)</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="radioTypeonly" label="3">Product Life Cycle Assessment (ISO 14067)</el-radio>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div v-if="radioTypeonly == '1'">
                    <div class="s_txt mg">Organization Type</div>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="3">Building Management</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="4">Government Agencies</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="5">Consulting Services</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="6">Hospitality</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="7">Education</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="8">Transportation</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="9">Financial Institution</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="10">Other</el-radio>
                      </el-col>
                    </el-row>
                    
                  </div>
                  <div>
                    <el-button class="bths" @click="goto3">Next</el-button>
                  </div>
                </div>

                <div v-else-if="selection_Name == 2">
                  <div>
                    <div class="s_txt mg">Carbon Footprint for </div>
                    <div class="radio mgr">
                      <el-radio v-model="radiofoott1" disabled label="1">Reporting Only</el-radio>
                    </div>
                    <div class="radio mgr">
                      <el-radio v-model="radiofoott1" label="2">Reporting and ISO certification</el-radio>
                    </div>
                    <div class="s_txt mg">Project Type Selection</div>
                    <div class="radio mgr">
                      <el-radio v-model="radioTypeonly" label="1">Organization Level (ISO 14064-1)</el-radio>
                    </div>
                    <div class="radio mgr">
                      <el-radio v-model="radioTypeonly" label="2">Project Level (ISO 14064-2)</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="radioTypeonly" label="3">Product Life Cycle Assessment (ISO 14067)</el-radio>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div v-if="radioTypeonly == '1'">
                    <div class="s_txt mg">Organization Type</div>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="3">Building Management</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="4">Government Agencies</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="5">Consulting Services</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="6">Hospitality</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="7">Education</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="8">Transportation</el-radio>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20" class="radio mgr">
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="9">Financial Institution</el-radio>
                      </el-col>
                      <el-col :span="8">
                        <el-radio v-model="radioTypeonly" label="10">Other</el-radio>
                      </el-col>
                    </el-row>
                    
                  </div>
                  <div>
                    <el-button class="bths" @click="goto3">Next</el-button>
                  </div>
                </div>

                <div v-if="!selection_Name">
                  <div>
                    <div class="s_txt mg">Carbon Footprint for </div>
                    <div class="radio mgr">
                      <el-radio v-model="radiofoot" label="1">Reporting Only</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="radiofoot" label="2">Reporting and ISO certification</el-radio>
                    </div>
                    <el-divider></el-divider>
                    <div v-if="radiofoot == '2'">
                      <div class="s_txt mg">Certification Agency Selection </div>
                      <div class="radio mgr">
                        <el-radio v-model="radiofoottype" label="1">British Standards Institution (BSI)</el-radio>
                      </div>
                      <div class="radio">
                        <el-radio v-model="radiofoottype" label="2">TÜV SÜD</el-radio>
                      </div>
                    </div>
                    <div>
                      <el-button  @click="gotoCarBonM" class="bths">Next</el-button>
                    </div>
                    <div class="cf_ad">
                      <div class="cf_ad_txt1">If You Are Not Sure How to Proceed, You May Want to</div>
                      <div class="cf_ad_txt2" @click="gotofive">Engage a Carbon Footprint/Neutrality Service Provider Approved by the Registry</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div v-if="activeName_CF == 2">

              <div class="overview_wrap cf_box">

                <!-- <div v-if="!selection_Name"></div> -->

                <div v-if="selection_Name == 1">
                  <div class="menu">
                    <div :class="activityindex == 1 ? 'hv' : ''" @click="activityindex=1" class="mn_t">Import Data</div>
                    <div :class="activityindex == 2 ? 'hv' : ''" @click="activityindex=2" class="mn_t">Enter Data</div>
                  </div>
                  <div class="banner_chek">
                    <div v-if="activityindex == 1">
                      <div class="s_txt mgr" v-if="subtbl">Choose Datasets to Import</div>
                      <div class="s_txt mgr" v-if="!subtbl">Review Imported Data</div>
                      <div v-if="subtbl">
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp1">Direct GHG emissions and removals (Scope 1)</el-checkbox>
                          </div>
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp2">Indirect GHG emissions from imported energy (Scope 2)</el-checkbox>
                          </div>
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp3">Indirect GHG emissions from transportation (Scope 3)</el-checkbox>
                          </div>
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp4">Indirect GHG emissions from products used by organization (Scope 3)</el-checkbox>
                          </div>
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp5">Indirect GHG emissions associated with the use of products from the organization (Scope 3)</el-checkbox>
                          </div>
                          <div class="chk_box mgr">
                            <el-checkbox v-model="checkedsp6">Indirect GHG emissions from other sources (Scope 3)</el-checkbox>
                          </div>
                          <div>
                            <el-button class="bths" @click="sub2">Submit</el-button>
                          </div>
                      </div>
                      <div v-if="!subtbl">
                        <img src="../../assets/img/tb_img.png" alt="">
                        <el-row type="flex" :gutter="20">
                          <el-col :span="5">
                            <el-button class="action" style="margin-top:37px">Edit</el-button>
                          </el-col>
                          <el-col>
                            <el-button class="bths" @click="selection_Name = 2">Confirm</el-button>
                          </el-col>
                        </el-row>
                        
                      </div>

                    </div>
                    <div v-if="activityindex == 2">
                      <div class="s_txt mgr">Manual Data Entry</div>
                      <div class="radio mgr">
                        <el-radio v-model="menuradio" label="1">Download Spreadsheet for Offline Entry</el-radio>
                      </div>
                      <div class="radio">
                        <el-radio v-model="menuradio" label="2">Enter Data On-line</el-radio>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="selection_Name == 2">
                  <div class="s_txt mgr" style="text-align:center">Green House Gas Emissions Inventory</div>
                  <div>
                    <img src="../../assets/img/cf_1.png" alt="">
                    <img src="../../assets/img/cf_2.png" alt="">
                    <img src="../../assets/img/cf_3.png" alt="">
                    <el-button class="bths" @click="pushchange">Next</el-button>
                  </div>
                </div>

                <div v-if="selection_Name == 3" style="text-align:center">
                  <div class="s_txt mgr">Connect to Your Organization’s Databases</div>
                  <div class="s_txt" style="font-style: italic;">(This Function is Available through the CMS-CF System.)</div>
                </div>

              </div>
            </div>

            <div v-if="activeName_CF == 3">
              <div class="overview_wrap cf_box">

                <div v-if="!selection_Name"></div>

                <div v-if="selection_Name == 1">
                  <div class="fen_box">
                    <div class="s_txt">Generate Tables, Figures, and Report</div>
                    <el-button class="bths btn_mg">Proceed</el-button>
                  </div>
                  <div class="fx_b">
                    <el-button class="bths bthClear btn_w">Download Report</el-button>
                  </div>
                  <div class="sts_txt">User downloads and modifies offline if necessary</div>
                  <div class="fx_b">
                    <el-button class="bths" v-if="radiofoot == '2'" @click="selection_Name=2" style="width:auto;padding:0 20px">Submit report for certification</el-button>
                  </div>
                </div>

                <div v-if="selection_Name == 2">
                  <div>
                    <div class="s_txt mg">Checklist of Required Documents for Carbon Footprint Certification</div>
                    <div class="radio mgr">
                      <el-radio v-model="cklistradio" label="1">Carbon Footprint Report </el-radio>
                    </div>
                    <div class="radio mgr">
                      <el-radio v-model="cklistradio" label="2">Tables of Emission Source List and Calculations</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="cklistradio" label="3">Contract with BSI</el-radio>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div v-if="cklistradio == '1'">
                    <div class="s_txt mg">Choose Report to Submit</div>
                    <div class="radio mgr">
                      <el-radio v-model="cklistradio_type" label="1">Use Report Generated by the Registry</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="cklistradio_type" label="2">Upload your Report</el-radio>
                      <el-button class="bths btn_mg">Upload</el-button>
                    </div>
                    <div>
                      <el-button class="bths" @click="goto4()">Next</el-button>
                    </div>
                  </div>
                  <div v-if="cklistradio == '2'">
                    <div class="s_txt mg">Choose Tables to Submit</div>
                    <div class="radio mgr">
                      <el-radio v-model="cklistradio_type" label="1">Tables Generated by the Registry</el-radio>
                    </div>
                    <div class="radio">
                      <el-radio v-model="cklistradio_type" label="2">Upload your Tables</el-radio>
                      <el-button class="bths btn_mg">Upload</el-button>
                    </div>
                    <div>
                      <el-button class="bths" @click="goto4()">Next</el-button>
                    </div>
                  </div>
                  <div v-if="cklistradio == '3'">
                    <div class="s_txt mg">Contract Submission</div>
                    <div class="radio mgr">
                      <el-radio v-model="cklistradio_type" label="1">Upload Contract</el-radio>
                      <el-button class="bths btn_mg">Upload</el-button>
                    </div>
                    <div class="radio">
                      <el-radio v-model="cklistradio_type" label="2">Request a Contract</el-radio>

                    </div>
                    <div>
                      <el-button class="bths" @click="goto4()">Next</el-button>
                    </div>
                  </div>
                  <div class="cf_ad">
                    <div class="cf_ad_txt1">If You Are Not Sure What to Submit, You May Want to</div>
                    <div class="cf_ad_txt2" @click="gotofive">Engage a Carbon Footprint/Neutrality Service Provider Approved by the Registry</div>
                  </div>
                </div>

              </div>
            </div>

            <div v-if="activeName_CF == 4">
              <div class="overview_wrap">
                <el-row>
                  <div class="title">
                    Process of Carbon Footprint Verification and Certification
                  </div>
                </el-row>
                <el-row type="flex" justify="center" style="margin-bottom:40px">
                    <div class="agency" :class="agency == 1 ? 'agencySel' : ''" @click="changeAgency(1)">By Agency</div>
                    <div class="agency" :class="agency == 2 ? 'agencySel' : ''" @click="changeAgency(2)">By Organization</div>
                </el-row>
                <el-row>
                <!-- table表格 -->
                  <div v-if="agency == 1">
                    <el-table
                      :data="
                        verificationList.slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize
                        )
                      "
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      :cell-style="columnStyle1"
                      style="width: 100%"
                    >
                      <el-table-column prop="step"  label="Steps" width="200px">
                        <template slot-scope="scope" >
                          <div class="listStep listStep_border">
                            <div>{{scope.$index +1}}.</div>
                            {{scope.row.step}}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" width="150px" label="Status">
                      </el-table-column>
                      <el-table-column
                        prop="responsibleParty"
                        label="Responsible Party"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="action"
                        label="Action"
                        width="320px"
                      >
                      <template slot-scope="scope">
                        <span v-if="scope.$index +1 == 7">{{scope.row.action}}</span>
                        <el-row type="flex" :gutter="20" v-else>
                          <el-col v-if="scope.row.action.split('/')[0]">
                            <div class="verificationbtn" @click="scope.row.action.split('/')[0] == 'Approve' 
                              ? verifiCationapprove(scope.row) : scope.row.action.split('/')[0] == 'Stage 1 Feedback' 
                              ? changeStageOneShow() : ''">
                              {{scope.row.action.split('/')[0]}}
                            </div>
                          </el-col>
                          <el-col v-if="scope.row.action.split('/')[1]">
                            <div class="verificationbtn" @click="scope.row.action.split('/')[1] == 'Feedback' 
                              ? feedBack() : scope.row.action.split('/')[1] == 'Complete' 
                              ? completeB() : ''">
                              {{scope.row.action.split('/')[1]}}
                            </div>
                          </el-col>
                        </el-row>
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="nodeAddress"
                        label="NFDT Node Address"
                        width="100px"
                      >
                        <template  slot-scope="scope">
                          <span style="color:#158869;">
                            <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/address/' + scope.row.nodeAddress" >{{scope.row.nodeAddress}}</a>
                          </span>

                        </template>

                      </el-table-column>

                    </el-table>
                  </div>
                  <div v-if="agency == 2">
                    <el-table
                      :data="
                        verificationListTwo.slice(
                          (currentPage - 1) * pageSize,
                          currentPage * pageSize
                        )
                      "
                      stripe
                      :header-cell-style="{
                        background: '#F0F3F6',
                        color: '#626262',
                        fontSize: '14px',
                        fontFamily: 'ArialMT',
                        paddingTop: '17px',
                        paddingBottom: '15px',
                        paddingLeft:'20px'
                      }"
                      :cell-style="columnStyle1"
                      style="width: 100%"
                    >
                      <el-table-column prop="step"  label="Steps" width="200px">
                        <template slot-scope="scope" >
                          <div class="listStep listStep_border">
                            <div>{{scope.$index +1}}.</div>
                            {{scope.row.step}}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="status" width="150px" label="Status">
                      </el-table-column>
                      <el-table-column
                        prop="responsibleParty"
                        label="Responsible Party"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="action"
                        label="Action"
                        width="320px"
                      >
                      <template slot-scope="scope">
                        <span v-if="scope.$index +1 == 7">{{scope.row.action}}</span>
                        <el-row type="flex" :gutter="20" v-else>
                          <el-col v-if="scope.row.action.split('/')[0]">
                            <div class="verificationbtn" @click="scope.row.action.split('/')[0] == scope.row.action.split('/')[0] ? changeSchedule(scope) : ''">
                              {{scope.row.action.split('/')[0]}}
                            </div>
                          </el-col>
                          <el-col v-if="scope.row.action.split('/')[1]">
                            <div class="verificationbtn" @click="open(scope)">
                              {{scope.row.action.split('/')[1]}}
                            </div>
                          </el-col>
                        </el-row>
                      </template>
                      </el-table-column>
                      <el-table-column
                        prop="nodeAddress"
                        label="NFDT Node Address"
                        width="100px"
                      >
                        <template  slot-scope="scope">
                          <span style="color:#158869;">
                            <a target="_bliank" style="cursor:pointer;color:#158869;" :href="'https://rinkeby.etherscan.io/address/' + scope.row.nodeAddress" >{{scope.row.nodeAddress}}</a>
                          </span>

                        </template>

                      </el-table-column>

                    </el-table>
                  </div>
                </el-row>
              </div>
            </div>

            <div v-if="activeName_CF == 5">
              <div class="overview_wrap">
                <div class="report_wrap_w">
                  <div class="report_wrap">
                    <img src="../../assets/img/Image.png" alt="" class="report">
                    <el-button class="btn_wrap">
                      <img src="../../assets/img/xiazai.png" alt="">
                      Download Report
                    </el-button>
                  </div>
                  <div class="report_wrap">
                    <img src="../../assets/img/NFT.png" alt="" class="report">
                    <el-button class="btn_wrap">
                      <img src="../../assets/img/xiazai.png" alt="">
                      Download NFT
                    </el-button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="activeName_CF == 6">
              <div class="overview_wrap cf_box">
                <div>
                  <div class="s_txt mg">Service Providers Approved by the Registry</div>
                  <div class="radio mgr">
                    <el-radio v-model="radioService" label="1">MVGX</el-radio>
                  </div>
                  <div class="radio">
                    <el-radio v-model="radioService" label="2">Others</el-radio>
                  </div>
                  <div class="cf_ad" v-if="radioService == '1'">
                    <div class="s_txt mgr">MetaVerse Green Exchange</div>
                    <div class="s_h3 mgr">Email: contact@mvgx.com</div>
                    <div class="s_h3 mgr">Tel: +65 6993 0182</div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="activeName_CF == 7">
              <div class="overview_wrap cf_box">
                <div class="s_txt" style="text-align:center">This page is for registry administrator use only</div>
              </div>
            </div>
        </el-col>
      </el-row>


       <!-- Carbon Footprint -->
      <el-row type="flex" v-if="index == 3" :gutter="20" justify="space-between">
        <!-- 左侧 -->
        <el-col :span="10" class="left" >
          
          <el-collapse v-if="commandindex == 1" v-model="activeName_CN" @change="handleChangeCN" accordion>
            <el-collapse-item :class="{ aaa: activeName_CN == 1 }" title="Initiate a Carbon Neutrality Project" name="1">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 2 }" title="Quantify Carbon Footprint" name="2">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 3 }" title="Carbon Footprint Analytics" name="3">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 4 }" title="Develop and Implement a Carbon Management Plan" name="4">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 5 }" title="Offset Residual Carbon Footprint" name="5">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 6 }" title="Generate Reports and Submit for CN Certification" name="6">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 7 }" title="Carbon Neutrality Verification by Certification Agency" name="7">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 8 }" title="PAS 2060 CN Certificate and NFT Issuance" name="8">
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-if="commandindex == 2" v-model="activeName_CN" @change="handleChangeCN" accordion>
            <el-collapse-item :class="{ aaa: activeName_CN == 1 }" title="Registry Carbon Credits Analysis" name="1">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 2 }" title="Registry Carbon Footprint Analysis" name="2">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 3 }" title="National Carbon Emissions Analysis" name="3">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CN == 4 }" title="Progress Check on National Carbon Neutrality Goals" name="4">
            </el-collapse-item>
          </el-collapse>
        </el-col>

        <!-- 右侧 -->
        <el-col>
            <div v-if="activeName_CN == 1">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CN == 2">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CN == 3">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CN == 4">
              <div class="overview_wrap">
              </div>
            </div>

            <div v-if="activeName_CN == 5">
              <div class="overview_wrap">
              </div>
            </div>

            <div v-if="activeName_CN == 6">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CN == 7">
              <div class="overview_wrap cf_box">
                <div></div>
              </div>
            </div>

            <div v-if="activeName_CN == 8">
              <div class="overview_wrap cf_box">
                <div></div>
              </div>
            </div>
        </el-col>
      </el-row>

      <!-- Carbon Footprint -->
      <el-row type="flex" v-if="index == 4" :gutter="20" justify="space-between">
        <!-- 左侧 -->
        <el-col :span="10" class="left" >
          
          <el-collapse v-if="commandindex == 1" v-model="activeName_CR" @change="handleChangeCR" accordion>
            <el-collapse-item :class="{ aaa: activeName_CR == 1 }" title="National Greenhouse Gas Inventory" name="1">
              <div class="Tokenize">
                <el-collapse v-model="selection_Name_CR" @click="handleChangeProjectCR" accordion class="one">
                  <el-collapse-item title="- Data Aggregation" name="1">
                  </el-collapse-item>
                  <el-collapse-item title="- Data Check" name="2">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CR == 2 }" title="Inventory Review" name="2">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CR == 3 }" title="Report Generation and Submission" name="3">
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-if="commandindex == 2" v-model="activeName_CR" @change="handleChangeCR" accordion>
            <el-collapse-item :class="{ aaa: activeName_CR == 1 }" title="Report to National Authority" name="1">
              <div class="Tokenize">
                <el-collapse v-model="selection_Name_Authority" @click="handleChangeReport" accordion class="one">
                  <el-collapse-item title="- Direct Carbon Emissions" name="1">
                  </el-collapse-item>
                  <el-collapse-item title="- Carbon Removals" name="2">
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
            <!-- <el-collapse-item :class="{ aaa: activeName_CR == 2 }" title="Direct Carbon Emissions" name="2">
            </el-collapse-item>
            <el-collapse-item :class="{ aaa: activeName_CR == 3 }" title="Carbon Removals" name="3">
            </el-collapse-item> -->
          </el-collapse>
        </el-col>

        <!-- 右侧 -->
        <el-col>
            <div v-if="activeName_CR == 1">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CR == 2">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CR == 3">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CR == 4">
              <div class="overview_wrap">
              </div>
            </div>

            <div v-if="activeName_CR == 5">
              <div class="overview_wrap">
              </div>
            </div>

            <div v-if="activeName_CR == 6">
              <div class="overview_wrap cf_box">
              </div>
            </div>

            <div v-if="activeName_CR == 7">
              <div class="overview_wrap cf_box">
                <div></div>
              </div>
            </div>

            <div v-if="activeName_CR == 8">
              <div class="overview_wrap cf_box">
                <div></div>
              </div>
            </div>
        </el-col>
      </el-row>

      <!-- Exchange as a Service页面 -->
      <div v-if="index == 5">
        <Exchange/>
        <!-- <div>
          <img src="../../assets/img/1.png" alt="">
          <img src="../../assets/img/2.png" alt="">
          <img src="../../assets/img/3.png" alt="">
          <img src="../../assets/img/4.png" alt="">
          <img src="../../assets/img/5.png" alt="">
          <img src="../../assets/img/6.png" alt="">
          <img src="../../assets/img/7.png" alt="">
          <img src="../../assets/img/8.png" alt="">
          <img src="../../assets/img/9.png" alt="">
          <img src="../../assets/img/10.png" alt="">
          <img src="../../assets/img/11.png" alt="">
          <img src="../../assets/img/12.png" alt="">
        </div> -->
          
      </div>
    </div>

    <!-- Issue 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="centerDialogVisible" width="617px" center>
      <div class="dialog_title">{{$t("carbonIndex.numberofCredits")}}</div>
      <div class="ipt_box">
        <el-input v-model="issuedata" placeholder="Please enter"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="action_btn" @click="changeissuedia()" style="width:125px">Confirm</div>
      </span>
    </el-dialog>
    <!-- Issue 弹窗 -->
    <el-dialog :title="$t('carbonIndex.issuesTitle')" :close-on-click-modal="false" :visible.sync="dialogbool" width="717px" center>
       <el-divider></el-divider>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col :span="18" class="textone">{{$t("carbonIndex.issusCon")}}</el-col>
        <el-col :span="6" class="texttwo">{{addComma(fromIssue.issuedConventionalCredits)}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col :span="18" class="textone">{{$t("carbonIndex.conCredits")}}</el-col>
        <el-col :span="6" class="texttwo">{{addComma(fromIssue.conventionalCredits)}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col :span="18" class="textone">{{$t("carbonIndex.tokenCarbon")}}</el-col>
        <el-col :span="6" class="texttwo">{{addComma(fromIssue.tokenizedCarbonCredits)}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col :span="18" class="textone">{{$t("carbonIndex.issusCNTs")}}</el-col>
        <el-col :span="6" class="texttwo">{{addComma(fromIssue.CNTs)}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col :span="18" class="textone">{{$t("carbonIndex.issusCNTs_C")}}</el-col>
        <el-col :span="6" class="texttwo">{{addComma(fromIssue.C_CNTs)}}</el-col>
      </el-row>
    </el-dialog>
    <!-- Issue 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="centerDialogVisibletwo" width="617px" center>
      <div class="dialog_titles">{{$t("carbonIndex.numberofCreditsP")}}</div>
      <span slot="footer" class="dialog-footer">
        <div class="action_btn" @click="changeissuedianext()" style="width:125px">Upload</div>
      </span>
    </el-dialog>
    <!-- Issue 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="centerDialogVisiblethe" width="617px" center>
      <div style="text-align:center">
        <img  src="../../assets/img/duihao.png" alt="">
      </div>
      
      <div class="dialog_titles">Upload Success</div>
      
    </el-dialog>


    <!-- Document Upload 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="documentUploadShow" width="617px" center>
      <div class="dialog_titles">{{$t("carbonIndex.numberofCreditsP")}}</div>
      <span slot="footer" class="dialog-footer" style="display:flex">
        <div class="action_btn open_btn" @click="changeDocumentUpload()" style="width:125px">{{$t('carbonIndex.public')}}</div>
        <div class="action_btn open_btn" @click="changeDocumentUpload()" style="width:125px">{{$t('carbonIndex.privary')}}</div>
      </span>
    </el-dialog>
    <!-- Issue 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="subMitStepBool" width="617px" center>
      <div style="text-align:center">
        <img  src="../../assets/img/duihao.png" alt="">
      </div>
      
      <div class="dialog_titles">Submit Success</div>
      
    </el-dialog>

    <!-- Issue 弹窗 -->
    <el-dialog :title="$t('carbonIndex.TransactionQuantity_title')" :close-on-click-modal="false" :visible.sync="disabled_cabon" width="606px" center>
       <!-- <el-divider></el-divider> -->
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col class="textone">{{$t("carbonIndex.BuyerCountry")}}</el-col>
        <el-col class="texttwo">{{transactionform.buyerCountry}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col class="textone">{{$t("carbonIndex.SellerCountry")}}</el-col>
        <el-col class="texttwo">{{transactionform.sellerCountry}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col class="textone">{{$t("carbonIndex.TypeofCredits")}}</el-col>
        <el-col class="texttwo">{{transactionform.typeofCredits}}</el-col>
      </el-row>
      <el-row :gutter="20" type="flex" justify="space-between" class="dialog_flex">
        <el-col class="textone">{{$t("carbonIndex.TransactionQuantity")}}</el-col>
        <el-col class="texttwo">{{addComma(transactionform.transaction)}}</el-col>
      </el-row>
      <div @click="cleardialog()" class="btn_box_mg_dia">{{$t('exchange.Confirm')}}</div>
    </el-dialog>

    <el-dialog title="" :close-on-click-modal="false" :visible.sync="transaction_dia" width="617px" center>
      <div style="text-align:center">
        <img  src="../../assets/img/duihao.png" alt="">
      </div>
      
      <div class="dialog_titles">Corresponding Adjustment Successful</div>
      <div style="margin-top:20px">
        <el-divider ></el-divider>
      </div>
      <div class="dialog_box_title">{{$t('exchange.title_txt')}}</div>
      <div class="dialog_title_txt">{{$t('exchange.TokenizedCredits')}}{{tokenizedCreditsform.tokenizedCredits ? addComma(tokenizedCreditsform.tokenizedCredits) : '--'}}</div>
      <div class="dialog_title_txt">{{$t('exchange.CCNTs')}}{{tokenizedCreditsform.ccnts ? addComma(tokenizedCreditsform.ccnts) : '--'}}</div>
      
    </el-dialog>

    <!-- 点击No的弹窗 -->
    <!-- Issue 弹窗 -->
    <el-dialog title="" :close-on-click-modal="false" :visible.sync="select_transaction" width="606px" center>
       <!-- <el-divider></el-divider> -->
       <div class="dialog_titles"> The transaction is not completed !</div>
      <div @click="cleardialogNo()" class="btn_box_mg_dia">{{$t('exchange.Confirm')}}</div>
    </el-dialog>

    <el-dialog title="" :close-on-click-modal="false" :visible.sync="transaction_dia_error" width="617px" center>
      <div style="text-align:center">
        <img  src="../../assets/img/cuohao.png" alt="">
      </div>
      
      <div class="dialog_titles">{{transaction_dia_error_txt}}</div>
      
    </el-dialog>
    <!--approve  -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="verifiCationapproveShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px">
        Certification Agency Approval of Documents
      </div>
      <el-radio-group v-model="approveRadio"  @change="changeApproveRadio">
        <div class="radio mgr">
          <el-radio :label="1">Approve with Stage 1 On-site Visit <span style="font-weight:600">Exempted</span></el-radio>
        </div>
        <div class="radio ">
          <el-radio :label="2">Approve and Proceed to Stage 1 On-site Visit</el-radio>
        </div>

      </el-radio-group>
    </el-dialog>
    <!-- approve one -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="approveOneShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        Schedule Stage 1 On-Site Visit by <br> Certification Agency
      </div>
      <div class="onSite">
        On-site Visit Exempted
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button class="verificationbtn" @click="approveOneConfirm">
          Confirm
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="scheduleOnSiteShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        <span v-if="scheduleVal == 3">
          Schedule Stage 1 On-Site Visit by<br> Certification Agency
        </span>
        <span v-if="scheduleVal == 4">
          Schedule Stage 2 On-Site Visit by<br> Certification Agency
        </span>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;margin-top:30px">
        <el-button class="verificationbtn" @click="closeScheduleOnSite">
          Schedule a Visit
        </el-button>
      </div>
    </el-dialog>
    <!-- 选择时间 -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="onSiteVisitTimeShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;">
        Choose an on-site visit time
      </div>
      <div class="datePicker">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="Please Select">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;margin-top:30px">
        <!-- class="verificationbtn" -->
        <el-button class="verificationbtn" :disabled="!date"  @click="closeonSiteVisitTimeConfirm">
          Confirm
        </el-button>
      </div>
    </el-dialog>

     <!--  -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="onSiteVisitTimeShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;">
        Choose an on-site visit time
      </div>
      <div class="datePicker">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="Please Select">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;margin-top:30px">
        <!-- class="verificationbtn" -->
        <el-button class="verificationbtn" :disabled="!date"  @click="closeonSiteVisitTimeConfirm">
          Confirm
        </el-button>
      </div>
    </el-dialog>

    <!-- feedBack -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="feedBackShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        Certification Agency
      </div>
      <div class="onSite">
        Upload Document Review Feedback
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button class="verificationbtn verificationbtn1" @click="feedBackShow = false" >
          <img src="../../assets/img/xia.png" alt="">
          Upload
        </el-button>
      </div>
    </el-dialog>

    <!-- submit -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="feedBackShowsubmit" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        User Organization Response
      </div>
      <div class="onSite">
        <span v-if="submitResponseVal == 3">
          Upload Responses to Stage 1 Agency Report and Updated Carbon Footprint Report & Calculations
        </span>
        <span v-if="submitResponseVal == 4">
          Upload Responses to Stage 2 Agency Report and Updated Carbon Footprint Report & Calculations
        </span>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button class="verificationbtn verificationbtn1" @click="feedBackShowsubmit = false" >
          <img src="../../assets/img/xia.png" alt="">
          Upload
        </el-button>
        <el-button class="verificationbtn btns" @click="feedBackShowsubmit = false" >
          Submit
        </el-button>
      </div>
    </el-dialog>

    <!-- feedBack -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="feedBackShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        Certification Agency
      </div>
      <div class="onSite">
        Upload Document Review Feedback
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button class="verificationbtn verificationbtn1" @click="feedBackShow = false" >
          <img src="../../assets/img/xia.png" alt="">
          Upload
        </el-button>
      </div>
    </el-dialog>

     <!--Complete  -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="CompleteShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px">
        Completion of Stage 1 Verification
      </div>
      <el-radio-group v-model="approveRadio"  @change="changeApproveRadio">
        <div class="radio mgr">
          <el-radio :label="1">Approve with Stage 2 On-site Visit Exempted </el-radio>
        </div>
        <div class="radio ">
          <el-radio :label="2">Approve and Proceed to Stage 2 On-site Visit</el-radio>
        </div>
      </el-radio-group>
    </el-dialog>

    <!-- Stage 1  -->
    <el-dialog title="" class="verifiCation"  :close-on-click-modal="false" :visible.sync="StageOneShow" width="617px" center>
      <div style="font-weight:bold;color:#1E1E1E;font-size:24px;margin-top:30px;text-align:center">
        Certification Agency
      </div>
      <div class="onSite">
        Upload Stage 1 Verification Report
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <el-button class="verificationbtn verificationbtn1" @click="StageOneShow = false" >
          <img src="../../assets/img/xia.png" alt="">
          Upload
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Headers from "@/components/header/index.vue";
import MAPS from "@/components/map/index.vue"
import Exchange from "@/components/carbon/exchange.vue"
import carbonRegistry from "@/api/carbonRegistry.js";
import { formatDate, formatDateTime } from "@/util/date";
import Carbon0 from "./carbon0.vue"
import Carbon1 from "./carboncredit.vue"
import Carbon2 from "./crabon2.vue"
import CarbonTransfer0 from './CarbonTransfer0.vue'
import CarbonTransfer1 from './CarbonTransfer1.vue'
import CarbonTransfer2 from './CarbonTransfer2.vue'
import SystemLog from "./systemlog.vue"
export default {
  components: { Headers , MAPS , Exchange, Carbon0, Carbon1, Carbon2, CarbonTransfer0, CarbonTransfer1, CarbonTransfer2, SystemLog },
  data() {
    return {
      index: 1,
      activeName: "1",
      steps:null,
      t1:'',
      t2:'',
      t3:'',
      stepnum:1,
      activeName_CF:1,
      activeName_CN:1,
      activeName_CR:1,
      issuedata:'',
      issueId:'',
      disabled:true,
      submitbool:true,
      feedBackShowsubmit:false,
      subMitStepBool:false,
      transaction_dia:false,
      transaction_dia_error:false,
      transaction_dia_error_txt:'',
      select_transaction:false,
      transactionform:'',
      tokenizedCreditsform:'',
      activeNames: [],
      activeNamestep:[],
      projectIdList:[],
      nfdtList:[],
      projectArr:[],
      issueList:[],
      cmccprojectsIntroducedList:[],
      carFrom:'',
      credits:'',
      projectId:'',
      nfdt:'',
      projectIdindex:'',
      nfdtindex:'',
      MakeCarbonSel:1,
      projectIdBool:false,
      centerDialogVisible:false,
      centerDialogVisibletwo:false,
      centerDialogVisiblethe:false,
      dialogbool:false,
      stepnum1:false,
      stepnum2:false,
      stepnum3:false,
      stepnum4:false,
      stepnum5:false,
      stepnum6:false,
      stepnum7:false,
      stepproject:false,
      creditsselbool:false,
      pageSize: 10,
      currentPage: 1,
      projectSiteId:'',
      fromIssue:'',
      selection_Name_CR:'',
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      tableData: [],
      sel: 1,
      form: {
        projectSiteId: "",
        projectName: "",
        projectType: "",
        creditMethodology: "",
        country: "",
      },
      countryList: [],
      countrySel: null,
      provinceStateSel:[],
      typeList: [],
      typeSel: null,
      methodologyList: [],
      methodologySel: null,
      currentActiveName: "2",
      creditssel: null,
      transactionsSel: null,
      carbonCreditIndex:'1',
      carbonTransferIndex:'1',
      active:null,
      creditsSel:null,
      selection_cf:null,
      selection_Name:null,
      labelPosition:'top',
      radioType:'1',
      radioTypeonly:'',
      radiofoot:'',
      radiofoottype:'',
      menuradio:'1',
      radiofoott1:'2',
      radiofoott2:'1',
      cklistradio:'',
      radioService:'',
      cklistradio_type:'',
      commandindex:'',
      stepsCarbon:1,
      stepsCarbonCn:1,
      activityindex:1,
      nextfirst:false,
      nexttwo:false,
      checkedsp1:true,
      checkedsp2:false,
      checkedsp3:false,
      checkedsp4:false,
      checkedsp5:false,
      checkedsp6:false,
      subtbl:true,
      data:{
        objective:"",
        name:'',
        country:"",
        developer:'',
        standards:'',
        period:'',
        qualification:'',
        type:'',
        state:'',
        verifier:'',
        methodology:'',
        credits:'',
      },
      login:{},
      provinceState:[],
      disabled_cabon:false,
      ConbonList:[
        {
          date:"2022.06.03 13:25",
          BuyerId:'1002',
          sellId:'1001',
          type:'Conventional',
          Transaction:'1,000',
          projectId:"850"
        },
        {
          date:"2022.06.03 15:25",
          BuyerId:'1002',
          sellId:'1445',
          type:'Conventional',
          Transaction:'2,500',
          projectId:"395"
        },
      ],
      nfConbonList:[
        {
          date:"2022.06.03 14:25",
          BuyerId:'1003',
          sellId:'1001',
          type:'Tokenized',
          Transaction:'2,000',
          projectId:"0x9e89122813cb438d13655c5866c527a48e634729"
        },
        {
          date:"2022.06.03 14:29",
          BuyerId:'1003',
          sellId:'1355',
          type:'Tokenized',
          Transaction:'5,000',
          projectId:"0x9e89122813cb438d13655c5866c527a48e634729"
        },
      ],
      tokenCarbonSel:null,
      projectsIntroducedList:[],
      nfdtSearchList:[],
      steps:null,
      initiativeNewProjectList:[
        {
          step:'Project Listing Request',
          ResponsibleParties:'Project Proponent',
          action:'Requests to list the project on the Registry',
          documents:'Draft PDD',
          nodeAddress:'0xc6963De43478F52212995Fed91961550a7640C68'
        },
        {
          step:'VVB Engagement',
          ResponsibleParties:'Project Proponent',
          action:'Contracts a VVB',
          documents:'Signed Contract',
          nodeAddress:'0x9e89122813cb438d13655c5866c527a48e634729'
        },
        {
          step:'PDD Completion',
          ResponsibleParties:'Project Proponent & VVB',
          action:'Complete the PDD',
          documents:'Complete PDD',
          nodeAddress:'0x8050E7497e86BEa4277cC8D4E7a99485534c44fF'
        },
        {
          step:'Public Comment',
          ResponsibleParties:'Registry',
          action:'Publishes PDD and Opens for Comments',
          documents:'Public Notice',
          nodeAddress:'0x9e89122813cb438d13655c5866c527a48e634729'
        },
        {
          step:'Project Implementation',
          ResponsibleParties:'Project Proponent',
          action:'Builds the project & Implements a Monitoring Plan',
          documents:'',
          nodeAddress:'0x8050E7497e86BEa4277cC8D4E7a99485534c44fF'
        },
        {
          step:'Validation and Verification',
          ResponsibleParties:'VVB',
          action:'Validates the Project Implementation and Verifies Credit Value',
          documents:'',
          nodeAddress:'0x9e89122813cb438d13655c5866c527a48e634729'
        },
        {
          step:'Registration Application',
          ResponsibleParties:'Project Proponent',
          action:'Applies for Project Registration on the Registry',
          documents:'Validation and Verification Reports etc. ',
          nodeAddress:'0x8050E7497e86BEa4277cC8D4E7a99485534c44fF'
        },
        {
          step:'Project Review',
          ResponsibleParties:'Registry',
          action:'Reviews Project Validation and Verification Reports',
          documents:'Review Results ',
          nodeAddress:'0x9e89122813cb438d13655c5866c527a48e634729'
        },
        {
          step:'Project Registration',
          ResponsibleParties:'Registry',
          action:'Registers the Project',
          documents:'Registration Notice',
          nodeAddress:'0x8050E7497e86BEa4277cC8D4E7a99485534c44fF'
        },
        {
          step:'Project Maintenance',
          ResponsibleParties:'Project Proponent & VVB',
          action:'Continue with Project Maintenance and Monitoring',
          documents:'',
          nodeAddress:'0x9e89122813cb438d13655c5866c527a48e634729'
        }
      ],
      mamageProjectList:[
        {
          date:'June 8, 2022',
          ActionRequested:'Initial Listing Request (Step 1)',
          id:'4320',
          projectName:'ABC Carbon Project',
          projectProponent:'The Emission Eliminator',
          projectvvb:'N/A',
          DocumentsSubmitted:'Draft PDD',
          manProjectAddress:'0x9e89122813cb438d13655c5866c527a48e634729',
          NumberofCredits:'5,000'
        },
        {
          date:'March 1, 2021',
          ActionRequested:'Project Validation and Verification (Step 6)',
          id:'369',
          projectName:'EFG Carbon Project',
          projectProponent:'The Carbon Sequester',
          projectvvb:'VVB Unlimited',
          DocumentsSubmitted:'Validation Report,  Verification Report',
          manProjectAddress:'0x9e89122813cb438d13655c5866c527a48e634729',
          NumberofCredits:'8,000'

        }
      ],
      mamageProjectList_Manage:[
        // {
        //   date:'June 8, 2022',
        //   ActionRequested:'Tokenize Carbon Credits/CNTs/Freeze Credits',
        //   id:'4320',
        //   projectName:'Low pressure steam generation by recovering waste heat using Heat Re-claimers at Emirates CMS Power',
        //   projectProponent:'Emirates CMS Power Company',
        //   projectvvb:'TUV Nord',
        //   DocumentsSubmitted:'Draft PDD',
        //   manProjectAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
        //   NumberofCredits:'5000'
        // },
        // {
        //   date:'June 1, 2021',
        //   ActionRequested:'Freeze Credits',
        //   id:'2580',
        //   projectName:'Nfapro rehabilitation of logged-over dipterocarp forest',
        //   projectProponent:'Face the Future',
        //   projectvvb:'SCS Global Service',
        //   DocumentsSubmitted:'Request Statement',
        //   manProjectAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
        //   NumberofCredits:'1000'

        // },
        // {
        //   date:'March 1, 2021',
        //   ActionRequested:'Issue Carbon Credits',
        //   id:'3690',
        //   projectName:'EFG Carbon Project',
        //   projectProponent:'The Carbon Sequester',
        //   projectvvb:'VVB Unlimited',
        //   DocumentsSubmitted:'Validation Report,  Verification Report',
        //   manProjectAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
        //   NumberofCredits:'8000'

        // }
      ],
      ProjectList_Carbon:[
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Malaysia',
          sellerID:'1001',
          sellerCountry:'Egypt',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1001',
          sellerCountry:'Egypt',
          typeofCredits:'C-CNTs',
          transaction:'5000',
          nfdtAddress:'0x3814eb41dd7cc5822bed68c4c74b3ef8c8851f38961a9139725da011286d3e71',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Indonesia',
          sellerID:'1001',
          sellerCountry:'Egypt',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0x9cebdd02b7db65485831b6c21a2a128bcd662f34cebc1e51d29db7576ae6822f',
          isclick:false,
        },
      ],
      ProjectList_Carbon_ASEAN:[
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1101',
          sellerCountry:'Indonesia',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1202',
          sellerCountry:'Malaysia',
          typeofCredits:'C-CNTs',
          transaction:'5000',
          nfdtAddress:'0x3814eb41dd7cc5822bed68c4c74b3ef8c8851f38961a9139725da011286d3e71',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1202',
          sellerCountry:'Malaysia',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0x9cebdd02b7db65485831b6c21a2a128bcd662f34cebc1e51d29db7576ae6822f',
          isclick:false,
        },
      ],
      ProjectList_Carbon_ASEAN_China:[
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1301',
          sellerCountry:'China',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0xb7fdd2ee6c8b5102904357b8c8eb0d65a9815191f388722a28c6edb1adfb565a',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1401',
          sellerCountry:'China',
          typeofCredits:'C-CNTs',
          transaction:'5000',
          nfdtAddress:'0x3814eb41dd7cc5822bed68c4c74b3ef8c8851f38961a9139725da011286d3e71',
          isclick:false,
        },
        {
          date:'2022.06.03 14:25',
          buyerId:'1005',
          buyerCountry:'Singapore',
          sellerID:'1401',
          sellerCountry:'China',
          typeofCredits:'Tokenized Credits',
          transaction:'2000',
          nfdtAddress:'0x9cebdd02b7db65485831b6c21a2a128bcd662f34cebc1e51d29db7576ae6822f',
          isclick:false,
        },
      ],
      InfoHome:{},
      documentUploadShow:false,
      friendShipCountry:['ALL','Egypt', 'Saudi','UAE'],
      friendShipCountryAsean:['ALL','Malaysia','Indonesia','Singapore'],
      friendShipCountryChina:['ALL','China','Singapore'],
      friendShipCountrySel:null,
      verificationList:[
        {
          step:'Documents Submitted',
          status:'Complete',
          responsibleParty:'Organization/Consultancy',
          action:'',
          nodeAddress:''
        },
        {
          step:'Document Review',
          status:'Under Review',
          responsibleParty:'Agency',
          action:'Approve/Feedback',
          nodeAddress:''
        },
        {
          step:'Stage 1 Verification',
          status:'Not Started',
          responsibleParty:'Organization + Consultancy + Agency',
          action:'Stage 1 Feedback/Complete',
          nodeAddress:''
        },
        {
          step:'Stage 2 Verification',
          status:'Not Started',
          responsibleParty:'Organization + Consultancy + Agency',
          action:'Stage 2 Feedback/Complete',
          nodeAddress:''
        },
        {
          step:'Internal Review',
          status:'Not Started',
          responsibleParty:'Agency',
          action:'Approve/Feedback',
          nodeAddress:''
        },
        {
          step:'Certification',
          status:'Not Started',
          responsibleParty:'Agency',
          action:'Issue Certificate',
          nodeAddress:''
        },
        {
          step:'NFT Creation',
          status:'Not Started',
          responsibleParty:'Not Started',
          action:'Issue MVGX Certificate and Create NFT on the blockchain',
          nodeAddress:''
        },
      ],
      verificationListTwo:[
        {
          step:'Documents Submitted',
          status:'Complete',
          responsibleParty:'Organization/Consultancy',
          action:'',
          nodeAddress:''
        },
        {
          step:'Document Review',
          status:'Under Review',
          responsibleParty:'Agency',
          action:'',
          nodeAddress:''
        },
        {
          step:'Stage 1 Verification',
          status:'Not Started',
          responsibleParty:'Organization/Consultancy + Agency',
          action:'Schedule On-site Visit/Submit Response',
          nodeAddress:''
        },
        {
          step:'Stage 2 Verification',
          status:'Not Started',
          responsibleParty:'Organization/Consultancy + Agency',
          action:'Schedule On-site Visit/Submit Response',
          nodeAddress:''
        },
        {
          step:'Internal Review',
          status:'Not Started',
          responsibleParty:'Agency',
          action:'',
          nodeAddress:''
        },
        {
          step:'Certification',
          status:'Not Started',
          responsibleParty:'Agency',
          action:'',
          nodeAddress:''
        },
        {
          step:'NFT Creation',
          status:'Not Started',
          responsibleParty:'MVGX',
          action:'Issue MVGX Certificate and Create NFT on the blockchain',
          nodeAddress:''
        },
      ],
      verifiCationapproveShow:false,
      radio:null,
      approveOneShow:false,
      approveRadio:null,
      agency:1,
      scheduleOnSiteShow:false,
      onSiteVisitTimeShow:false,
      date:'',
      dateDisabled:true,
      feedBackShow:false,
      CompleteShow:false,
      StageOneShow:false,
      selection_Name_Authority:'',
      scheduleVal:'',
      submitResponseVal:'',
      tonnesList:[
        {
          tonnes:'Registry Carbon Credits Total',
          valueTwo:'TBD',
          valueOne:''
        },
        {
          tonnes:'Registry Carbon Footprint Total',
          valueTwo:'TBD',
          valueOne:'TBD'
        },
        {
          tonnes:'National Carbon Emissions',
          valueTwo:'TBD',
          valueOne:'TBD'
        }
      ]
    };
  },
  created(){
    this.login = JSON.parse(sessionStorage.getItem('login'))
  },
  mounted() {
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        that.windowWidth = document.documentElement.clientWidth, //实时屏幕宽度
        that.windowHeight = window.fullHeight; // 高
      })();
    };
    
    if(that.login){
      that.getCountry();
      that.getProjectType();
      that.getMethodology();  
      that.getRegistryState();
      that.getprojectId();
      that.projectsIntroduced();
      that.getIssueList();
      that.projectInfoHome();
      this.getcarbonTotal()
    }
    
  },
  beforeRouteEnter(to, from, next) {
    if(from.name == 'Home'){
      to.meta.keepAlive = true;
      console.log(1)
      to.meta.isBack = true;
    } // 当从上个页面corporateInfo返回当前页面时，不刷新当前页面
     next();
  },
  // 注意activated只能在keep-alive组件中调用
  activated() {
        if(!this.$route.meta.isBack == false){
              // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
              this.$router.go(0)  //刷新当前页面
        }
        // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
        this.$route.meta.isBack=false
  },
  methods: {
    formatDate: formatDate,
    handleCommand(val){
      console.log(val)
      this.commandindex = val
      this.index = 3
    },
    handleCommand4(val){
      console.log(val)
      this.commandindex = val
      this.index = 4
    },
    goto3(){
      this.activeName_CF = 2
      this.selection_Name = 1
      // this.stepsCarbon = 2
    },
    sub2(){
      this.stepsCarbon = 2
      this.subtbl=false
    },
    // 点击approve
    verifiCationapprove(){
      this.verifiCationapproveShow = true
    },
    feedBack(){
      this.feedBackShow = true
    },
    completeB(){
      this.CompleteShow = true
    },
    changeStageOneShow(){
      this.StageOneShow = true
    },

    // 切换 changeApproveRadio
    changeApproveRadio(value){
      if(value == 1){
        this.verifiCationapproveShow = false
        this.approveOneShow = true
      }else{
        this.verifiCationapproveShow = false
        this.agency = 2
      }
    },
    closeScheduleOnSite(){
      this.scheduleOnSiteShow = false
      this.onSiteVisitTimeShow = true
    },
    closeonSiteVisitTimeConfirm(){
      this.onSiteVisitTimeShow = false
    },
    changeAgency(index){
      this.agency = index
    },
    approveOneConfirm(){
      this.approveOneShow = false
    },
    projectInfoHome(){
      let params = {
        country:this.login.country ? this.login.country : 'all',
        // groupId:this.login.groupId ? this.login.groupId : ''
      }
      carbonRegistry.projectInfoHome(res => {
        this.InfoHome = res.data
        this.tonnesList[0].valueOne = this.addComma(res.data.totalCreditsIssued) || 0
        
      },params)
    },
    getcarbonTotal(){
      let params = {
        country:this.login.country ? this.login.country : ''
      }
      carbonRegistry.getcarbonTotal(res => {
        // this.InfoHome = res.data
        if(res.code == 200){
          this.mamageProjectList_Manage = res.data.data
        }
      },params)
    },
    action(index){
      this.tokenCarbonSel = index
    },
    columnStyle({ row, column, rowIndex, columnIndex}){
      if(columnIndex == 1){
        return "color:#366F67;word-break:break-word;padding-left:20px";
      }
      return "word-break:break-word;padding-left:20px";
    },
    columnStyle1({ row, column, rowIndex, columnIndex}){

      return "word-break:break-word;padding-left:20px";
    },
    // 定义添加逗号的方法
    addComma(num = 0) {
        return num.toString().replace(/\d+/, function(n) {
            return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        });
    },
    changeCredits(index) {
      this.creditssel = index;
    },
    changeTransactions(index) {
      this.transactionsSel = index;
    },
    changeCarbonCreditIndex(index) {
      this.carbonCreditIndex = index;
    },
    changeCarbonTransferIndex(index) {
      this.carbonTransferIndex = index;
    },
    changeCreditsSel(index){
      this.creditssel = index
      this.tokenCarbonSel = ''
      this.clerSteps()
      this.form.projectSiteId = "";
      this.form.projectName = "";
      this.form.projectType = "";
      this.form.creditMethodology = "";
      this.form.country = "";
      this.typeSel = null;
      this.methodologySel = null;
      this.provinceStateSel = []
      this.activeNames = []
      this.tableData = []
      this.friendShipCountrySel = null
      if(this.countryList.length > 1){
        this.countrySel = null;
      }
      
    },
    clerSteps(){
      this.steps = null
      this.stepnum = 1
      this.stepnum1 = false
      this.stepnum2 = false
      this.stepnum3 = false
      this.stepnum4 = false
      this.stepnum5 = false
      this.stepnum6 = false
      this.stepnum7 = false
      this.projectIdBool = false
      this.stepproject = false,
      this.submitbool = true
      this.projectId = ''
      this.carFrom = ''
      this.nfdt = ''
      this.projectIdindex = ''
      this.activeNamestep = null
      this.nfdtindex = ''
      this.credits = ''
      this.projectSiteId = ''
      
    },
    changeTokenCarbonSel(val){
      this.tokenCarbonSel = val
      this.clerSteps()
      console.log(this.tokenCarbonSel)
    },
    changeMakeCarbonSel(val){
      this.MakeCarbonSel = val
    },
    getCountry() {
      carbonRegistry.getCountry((res) => {
        this.countryList = res.list;
        // if(this.countryList.length == 1){
        //   this.countrySel = 0
        // }
      },{country:this.login.country});
    },
    changeCountry(index) {
      this.countrySel = index;
      console.log(index)
      // if(index == 1){
        
      // }
    },
    changeProvinceState(index){
      this.provinceStateSel.push(index)
      console.log('this.provinceStateSel  change',this.provinceStateSel)
    },
    getProjectType() {
      carbonRegistry.getProjectType((res) => {
        this.typeList = res.list;
      },{country:this.login.country});
    },
    changeType(index) {
      this.typeSel = index;
    },
    changeprojectId(index,item){
      // this.projectArr = []
      this.projectId = item
      this.projectIdindex = index
      carbonRegistry.getProject(response =>{
        this.carFrom = response.project
        // this.projectArr.push(response.project)
      },{projectSiteId:item})
    },
    changeSchedule(row){
      console.log('row',row)
      this.scheduleVal = row.$index+1
      this.scheduleOnSiteShow = true
    },
    getMethodology() {
      carbonRegistry.getMethodology((res) => {
        this.methodologyList = res.list;
      },{country:this.login.country});
    },
    changeMethodology(index) {
      this.methodologySel = index;
    },
    changeFriendShipCountry(index){
      this.friendShipCountrySel = index
    },
    changenfdt(index,item){
      this.nfdt = item
      this.nfdtindex = index
    },
    tab(index) {
      console.log(index)
      this.index = index;
      if(index == 2){
        // this.activeName_CF = '1'
        // this.selection_Name = '3'
      }
    },
    open(row){
      this.submitResponseVal = row.$index+1
      this.feedBackShowsubmit = true
    },
    gotofive(){
      this.activeName_CF = 6
    },
    pushchange(){
      this.activeName_CF = 3
      this.selection_Name = 1
      this.stepsCarbon = 3
    },
    goto4(){
      this.activeName_CF = 4
      this.stepsCarbon = 4
      this.agency = 2
    },
    search() {
      console.log(this.login.type,this.activeName)
      if(this.login.type == 1){
        var data = {
          country:
            this.countrySel !== null ? this.countryList[this.countrySel] : "",
          projectSiteId: this.form.projectSiteId,
          projectName: this.form.projectName,
          projectType: this.typeSel !== null ? this.typeList[this.typeSel] : "",
          creditMethodology:
            this.methodologySel !== null
              ? this.methodologyList[this.methodologySel]
              : "",
          friendShipCountry:this.friendShipCountrySel !== null ? this.friendShipCountry[this.friendShipCountrySel] : "",
          groupId:this.login.groupId
        };
      }else if(this.login.type == 2){
        var data = {
          projectSiteId: this.form.projectSiteId,
          projectName: this.form.projectName,
          projectType: this.typeSel !== null ? this.typeList[this.typeSel] : "",
          creditMethodology:
            this.methodologySel !== null
              ? this.methodologyList[this.methodologySel]
              : "",
          states:this.provinceStateSel,
          country:this.login.country,
          friendShipCountry:this.friendShipCountrySel !== null ? this.friendShipCountry[this.friendShipCountrySel] : "",
          groupId:this.login.groupId
        };
        if(this.login.groupId == 2){
          var data = {
            projectSiteId: this.form.projectSiteId,
            projectName: this.form.projectName,
            projectType: this.typeSel !== null ? this.typeList[this.typeSel] : "",
            creditMethodology:
              this.methodologySel !== null
                ? this.methodologyList[this.methodologySel]
                : "",
            states:this.provinceStateSel,
            country:this.login.country,
            friendShipCountry:this.friendShipCountrySel !== null ? this.friendShipCountryAsean[this.friendShipCountrySel] : "",
            groupId:this.login.groupId
          };
        }
        if(this.login.groupId == 3){
          var data = {
            projectSiteId: this.form.projectSiteId,
            projectName: this.form.projectName,
            projectType: this.typeSel !== null ? this.typeList[this.typeSel] : "",
            creditMethodology:
              this.methodologySel !== null
                ? this.methodologyList[this.methodologySel]
                : "",
            states:this.provinceStateSel,
            country:this.login.country,
            friendShipCountry:this.friendShipCountrySel !== null ? this.friendShipCountryChina[this.friendShipCountrySel] : "",
            groupId:this.login.groupId
          };
        }
      }
      if(this.activeName == 5){
        carbonRegistry.submitNfdtLedgerList(res => {
          this.nfdtSearchList = res.data
          // this.projectInfoHome()
        },data)
      }else{
        carbonRegistry.getRegistryList((res) => {
          this.tableData = res.data.list;
          if(this.login.groupId){
            this.t1 = res.data.totalCreditsIssued;
            this.t2 = res.data.tokenizedCredits;
            this.t3 = res.data.CCNTs
          }
          
          // this.projectInfoHome()
          let params_search = {
            country:'',
            // groupId:''
          }
          // debugger
          if(this.login.groupId == 1){
            // params_search.groupId = this.login.groupId
            params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountry[this.friendShipCountrySel] : ""
            if(this.friendShipCountrySel){
              if(this.friendShipCountry[this.friendShipCountrySel] !== 'ALL'){
                // params_search.groupId = ''
                params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountry[this.friendShipCountrySel] : ""
              }
            }
          }else if(this.login.groupId == 2){
            // params_search.groupId = this.login.groupId
            params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountryAsean[this.friendShipCountrySel] : ""
            if(this.friendShipCountrySel){
              if(this.friendShipCountryAsean[this.friendShipCountrySel] !== 'ALL'){
                // params_search.groupId = ''
                params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountryAsean[this.friendShipCountrySel] : ""
              }
            }
          }else if(this.login.groupId == 3){
            // params_search.groupId = this.login.groupId
            params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountryChina[this.friendShipCountrySel] : ""
            if(this.friendShipCountrySel){
              if(this.friendShipCountryChina[this.friendShipCountrySel] !== 'ALL'){
                // params_search.groupId = ''
                params_search.country = this.friendShipCountrySel !== null ? this.friendShipCountryChina[this.friendShipCountrySel] : ""
              }
            }
          }else{
            // params_search.groupId = ''
            params_search.country = this.login.country ? this.login.country : 'all'
          }
          // carbonRegistry.projectInfoHome(res => {
          //   this.InfoHome = res.data
          //   this.tonnesList[0].valueOne = this.addComma(res.data.totalCreditsIssued) || 0
          // },params_search)
        }, data);
      }
      
    },

    projectsIntroduced(){
      var data = {
          country:this.login.country,
          projectSiteId: this.form.projectSiteId,
          projectName: this.form.projectName,
          projectType: this.typeSel !== null ? this.typeList[this.typeSel] : "",
          creditMethodology:
            this.methodologySel !== null
              ? this.methodologyList[this.methodologySel]
              : "",
          
      };
      carbonRegistry.getRegistryList((res) => {
        this.projectsIntroducedList = res.data.list;
        this.cmccprojectsIntroducedList = []
      },data);
    },
    clearSearch() {
      this.form.projectSiteId = "";
      this.form.projectName = "";
      this.form.projectType = "";
      this.form.creditMethodology = "";
      this.form.country = "";
      this.typeSel = null;
      this.methodologySel = null;
      this.provinceStateSel = []
      this.friendShipCountrySel = null
      if(this.countryList.length > 1){
        this.countrySel = null;
      }
    },
    //翻页
    handleCurrentChange(updateCurrentPage) {
      this.currentPage = updateCurrentPage;
    },
    handleChangeCN(val){
      this.activeName_CN = val
    },
    handleChangeCR(val){
      this.activeName_CR = val
    },
    gotoCarBonM(){
      if(this.radiofoot == '1'){
        this.selection_Name = '3'
      }
      if(this.radiofoot == '2'){
        this.selection_Name = '2'
      }
    },
    handleChangeCF(val){
      console.log(val)
      this.activeName_CF = val
      // this.selection_Name = '1'
      if(val == '1'){
        this.selection_Name = ''
        // this.radiofoot = ''
      }else{
        this.selection_Name = '1'
      }
      if(val == '5'){
        this.stepsCarbon = 6
      }
      console.log('activeName_CF',this.activeName_CF)
      
      
    },
    handleChange(val) {
      if (val != "") {
        this.currentActiveName = val;
      }
      if(val !== 2){
        this.active = null
      }
      if(val !== 3){
        this.creditssel = null
      }
      if(val !== 5){
        this.form.projectSiteId = "";
        this.form.projectName = "";
        this.form.projectType = "";
        this.form.creditMethodology = "";
        this.form.country = "";
        this.typeSel = null;
        this.methodologySel = null;
        this.provinceStateSel = []
        this.activeNames = []
        this.nfdtSearchList = []
        this.friendShipCountrySel = null
        if(this.countryList.length > 1){
          this.countrySel = null;
        }
      }
    },
    handleChangeProjectCF(val){
        this.selection_Name = val
        console.log(this.activeName_CF,val)
        if(this.activeName_CF == 1){
          if(val == 2){
            // this.radiofoot = '2'
          }else{
            // this.radiofoot = '1'
          }
        }
    },
    handleChangeProjectCR(val){
      this.selection_Name_CR = val
    },
    handleChangeReport(val){
      this.selection_Name_Authority = val
    },
    handleChangeProject(val){
      var act = val
      if (val != "") {
        this.active = val;
      }
      if(val == '' || act == 5){
        this.form.projectSiteId = "";
        this.form.projectName = "";
        this.form.projectType = "";
        this.form.creditMethodology = "";
        this.form.country = "";
        this.typeSel = null;
        this.methodologySel = null;
        this.provinceStateSel = []
        this.activeNames = []
        this.tableData = []
        this.friendShipCountrySel = null
        if(this.countryList.length > 1){
          this.countrySel = null;
        }
      }
    },
    getDetail(row) {
      this.$router.push({ path: "/carbonDetail", query: { id: row.id } });
      let data = {
        typeSel:this.typeSel,
        methodologySel:this.methodologySel,
        creditssel:this.creditssel,
        countrySel:this.countrySel,
        activeName:this.activeName,
        activeNames:this.activeNames,
        active:this.active
      }
      sessionStorage.setItem('form',JSON.stringify(this.form))
      sessionStorage.setItem('data',JSON.stringify(data))
    },
    getnfdtDetail(row){
      this.$router.push({ path: "/nfdtDetail", query: { id: row.id } });
    },
    changeOverview(sel) {
      this.sel = sel;
    },
    getRegistryState(){
      carbonRegistry.getRegistryState(res => {
          this.provinceState = res.data
          console.log('this.provinceState',this.provinceState)
      },{country:this.login.country})
    },
    changesteps(){

      if(this.stepnum == 1){
        this.stepnum1 = true
        this.steps = 1
        this.stepnum += 1
        return
      }
    },
    changestepstwo(){

      if(this.stepnum == 1){
        this.stepnum1 = true
        this.steps = 1
        this.stepnum += 1
        return
      }
      if(this.stepnum == 2){
        this.stepnum2 = true
        this.steps = 2
        this.stepnum += 1
        return
      }
    },
    getprojectId(){
      let params = {
        country:this.login.country ? this.login.country : 'Indonesia'
      }
      carbonRegistry.getprojectId(response =>{
        if(response.code == 200){
          this.projectIdList = response.data.projectIdList
          this.nfdtList = response.data.nfdtList
        }
      },params)
    },
    subMitStep(){
      if(this.stepnum == 1){
        this.stepnum1 = true
        this.steps = 1
        this.stepnum += 1
        return
      }
      if(this.stepnum == 2){
        this.centerDialogVisibletwo = true
        return
      }
      let params = {
        projectId:this.projectId,
        nfdt:this.nfdt,
        credits:this.credits,
      }
      this.subMitStepBool = false
      carbonRegistry.changeSubmit(response =>{
        console.log(response)
        // this.submitbool = false
        this.stepnum2 = true
        // this.stepnum3 = true
        // this.stepnum4 = true
        this.steps = 2
        this.stepnum += 1
        this.subMitStepBool = true
      },params)
    },
    subMitStepdon(){
      if(this.stepnum == 2){
        this.centerDialogVisiblethe = true
        this.stepnum += 1
      }
      
    },
    changeissuedianext(){
      this.centerDialogVisibletwo = false
      this.stepnum += 1
    },
    changeDocumentUpload(){
      this.documentUploadShow = false
    },
    changeprojectIdList(){
      let params = {
        projectSiteId:this.projectSiteId
      }
      this.projectArr = []
      carbonRegistry.getProject(response =>{
        console.log(123,response)
        this.steps = 3
        
        this.projectArr.push(response.project)
        this.projectIdBool = true 
        this.submitbool = false
        this.stepnum = 4
      },params)
    },
    backproject(){
      this.projectIdBool = false
      this.stepproject = true
      this.steps = 6
      this.stepnum3 = true
      this.stepnum4 = true
      this.stepnum5 = true
      this.stepnum6 = true
    },
    backprojects(){
      this.projectIdBool = false
      this.stepproject = true
      this.steps = 7
      this.stepnum3 = true
      this.stepnum4 = true
      this.stepnum5 = true
      this.stepnum6 = true
      this.stepnum7 = true
    },
    changeIssue(id){
      console.log(id)
      this.centerDialogVisible = true
      this.issueId = id
      // this.projectInfoHome();
    },
    changeIssuedetail(row){
        this.dialogbool = true
        this.fromIssue = row.issuance
    },
    changeissuedia(){
      let params = {
        id:this.issueId,
        creditsIssuanced:this.issuedata
      }
      carbonRegistry.confirmIssue(response =>{
        if(response.code == 200){
          this.centerDialogVisible = false
          this.issuedata = ''
          this.projectInfoHome();
        }
      },params)
      
    },
    //获取Issue列表
    getIssueList(){
      let params = {
        country:this.login.country ? this.login.country : 'Indonesia'
      }
      carbonRegistry.getIssueCarbon(response =>{
        if(response.code == 200){
          this.issueList = response.data
        }
      },params)
    },
    successSubmit(row,index){
      if(!row.isclick){
        this.transactionform = ''
        this.transactionformindex = ''
        this.transactionform = row
        this.transactionformindex = index
        this.disabled_cabon = true
      }
    },
    cleardialog(){
      let params = {
        buyerCountry:this.transactionform.buyerCountry,
        sellerCountry:this.transactionform.sellerCountry,
        typeOfCredits:this.transactionform.typeofCredits == 'Tokenized Credits' ? '2' : '4',
        transactionQuantity:this.transactionform.transaction
      }
      carbonRegistry.changeProjectInfo(response =>{
        this.transaction_dia_error_txt = ''
        this.tokenizedCreditsform = ''
        if(response.code == 200){
          this.disabled_cabon = false
          this.$set(this.ProjectList_Carbon[this.transactionformindex],'isclick',true)
          this.transactionform = ''
          this.transactionformindex = ''
          this.tokenizedCreditsform = response.data
          this.projectInfoHome();

          setTimeout(()=>{
            this.transaction_dia = true
          },500)
        }else{
          this.disabled_cabon = false
          setTimeout(()=>{
            this.transaction_dia_error_txt = response.message
            this.transaction_dia_error = true
          },500)
        }
      },params)
      
      
    },
    errSubmit(row,index){
      if(!row.isclick){
        this.transactionformindex = ''
        this.transactionformindex = index
        this.select_transaction = true
        // this.$set(this.ProjectList_Carbon[index],'isclick',true)
      }
    },
    cleardialogNo(){
      this.select_transaction = false
      this.$set(this.ProjectList_Carbon[this.transactionformindex],'isclick',false)
      this.transactionformindex = ''
    }
  },
};
</script>

<style lang="scss" scoped>
@import url(../../assets/css/miniBtc.css);
.mini_bg {
  width: 100%;
  height: 400px;
  // height: 350px;
  background: url("../../assets/img/minibj.png") no-repeat;
  background-size: 100% 100%;
}
.mini_bg1{
  width: 100%;
  padding-bottom: 20px;
  background: url("../../assets/img/minibj.png") no-repeat;
  background-size: 100% 100%;
}
.overview_wrap {
  background: #f8f9fa;
  padding: 45px;
  border-radius: 10px;
  .border {
    border-right: 1px solid #e5e5e5;
  }
  .title {
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1e1e1e;
    margin-bottom: 50px;
  }
  .one {
    margin-bottom: 39px;
    .name {
      font-size: 20px;
      font-family: ArialMT;
      color: #626262;
    }
    .nums {
      text-align: right;
      font-size: 22px;
      font-family: Arial-BoldMT, Arial;
      font-weight: bold;
      color: #424242;
    }
  }
  .one:last-child {
    margin-bottom: 0;
  }
}

.projects {
  padding: 0 20px;
}
.bth-wrap {
  margin-bottom: 20px;
}
.Country {
  height: 200px;
  overflow-y: scroll;
  li {
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    padding: 12px 0px;
    cursor: pointer;
  }
}

.Country1 {
  padding: 0 20px;
  li {
    list-style: none;
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    cursor: pointer;
    padding: 12px 0px;
  }
}
.overviewSel {
  color: #158869 !important;
  font-weight: bold;
}
.selbg{
  background: #F4FAF9 !important;
}

::v-deep .bth-wrap .el-button {
  padding: 0;
}
.bths {
  width: 125px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  font-size: 14px;
  font-family: ArialMT;
  color: #ffffff;
}
.bthClear {
  background: #ffffff;
  color: #158869;
  border: 1px solid #158869;
  // margin-left: 20px;
}
.aaa {
   ::v-deep .el-collapse-item__header {
    background-color: #158869 !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    padding: 0 20px !important;
  }

}
.p {
  ::v-deep .el-collapse-item__header {
    padding: 0 !important;
  }
}
.projects{
  ::v-deep .el-collapse-item__header{
    background-color: #fff !important;
    color: #1e1e1e !important;
  }
}

.Tokenize{
  ::v-deep .el-collapse-item__header{
    background-color: #fff !important;
    color: #1e1e1e !important;
    padding: 0 20px !important;
    color: #41566b !important;
    font-weight: 400 !important;
  }
  ::v-deep .el-collapse-item__wrap{
    padding: 0 20px !important;
  }
  ::v-deep .el-collapse-item__header.is-active {
    color: #158869 !important;
    font-weight: bold !important;

  }
  // ::v-deep .one > .el-collapse-item:nth-of-type(-n+4) .el-icon-arrow-right:before {
  //   content: " ";
  // }
  // ::v-deep .three > .el-collapse-item .el-icon-arrow-right:before {
  //   content: " ";
  // }
  // ::v-deep .three>.el-collapse-item:nth-child(2) .el-icon-arrow-right:before {
  //   content: "\e6e0";
  // }
  // ::v-deep .three>.el-collapse-item:nth-child(5) .el-icon-arrow-right:before {
  //   content: "\e6e0";
  // }
}
.form {
  ::v-deep .el-icon-arrow-right:first-child:before{
    content: "\e6e0";
  }
  ::v-deep .el-collapse-item__header{
    padding: 0  !important;
  }
  ::v-deep .el-collapse-item__wrap{
    padding: 0  !important;
  }
}
::v-deep .left .el-collapse-item__header.is-active {
  background-color: #158869;
  color: #ffffff;
  border-radius: 10px;
  padding: 0 12px;
}

::v-deep .projects .el-collapse-item__header.is-active {
  background-color: transparent;
  color: #158869 !important;
  padding: 0;
}

::v-deep .projects .el-collapse-item__wrap {
  // padding: 0 10px;
  border-bottom: none;
}

::v-deep .projects .el-form-item__label {
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1e1e1e;
}

::v-deep .left .el-collapse-item__content:first-child {
  padding: 0;
  border-bottom: none;
}

::v-deep .left .el-collapse-item__header {
  border: none;
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1e1e1e;
  line-height: normal;
  background-color: transparent;
  // color: #ffffff;
}
::v-deep .left .el-collapse {
  border-top: none;
  border-bottom: none;
}
::v-deep .projects .el-collapse {
  border-top: none;
  border-bottom: none;
}
.data-pic {
  width: 244px;
  height: 210px;
}
.nodata {
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
}

::v-deep .el-table::before {
  height: 0px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #f4f4f5;
    color: #158869;
}

::v-deep .el-collapse-item__wrap{
  border: none !important;
}

::v-deep .el-table .cell{
  word-break: break-word;
}

::v-deep .el-table{
  border-radius: 10px 10px 0 0;
}

.upload{
  width: 167px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid #158869;
  font-size: 14px;
  font-family: ArialMT;
  color: #158869;
}
.cancel{
  width: 125px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  font-size: 16px;
  font-family: ArialMT;
  color: #FFFFFF;
}
.confirm{
  background-color: #ffffff;
  color: #158869;
  border: 1px solid #158869;
}
::v-deep .el-button{
  padding: 0;
}

::v-deep .newProject .el-form-item__label{
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
}

::v-deep .Country{
  .el-checkbox__inner{
    display: none;
  }
  .el-checkbox-group{
    width: 100%;
  }
  .el-checkbox{
    width: 100%;
    font-size: 14px;
    font-family: ArialMT;
    color: #41566b;
    padding: 12px 0px;
    margin-right: 0;
  }
  .is-checked{
    font-weight: bold;
    background: #F4FAF9 !important;
  }
  .el-checkbox__label{
    padding-left: 0;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #158869  !important;
  }
}
.map_box{
    width: 100%;
    height: 457px;
    // background: pink;
}
::v-deep .steps{
  .el-step__description{
        margin-top:10px;
        font-size: 16px;
        padding-left: 10%;
        padding-right: 10%;
        line-height: 24px;
        color: #626262;
    }
    .el-step__line-inner{
        background-color: #158869;
    }
    .el-step__head.is-success{
        color: #158869;
        border-color: #158869;
    }
    .el-step.is-horizontal .el-step__line{
      top: 16px;
    }
    .el-step__icon{
      width: 37px;
      height: 37px;
    }
    .el-step__icon-inner{
      font-size: 16px;
      line-height: 37px;
    }

    .is-success {
        .el-step__icon.is-text{
            background-color: #158869;
            color: #ffffff;
        }

    }
    .el-step__description.is-success{
        color: #158869;
    }
    .el-step__description.is-process{
        color: #626262;
    }
    .is-process{
        .el-step__icon.is-text{
            background-color: #FFFFFF;
            color: #C0C4CC;
            border-color: #C0C4CC;
        }
    }

}
::v-deep .step_box{
  display: flex;
  justify-content: space-between;
  min-height: 530px;
  position: relative;
  .step_text{
    .text_step{
      cursor: pointer;
      .title_step{
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 28px;
      }
      .banner_step{
        margin-top: 18px;
        font-size: 20px;
        font-family: ArialMT;
        color: #626262;
        line-height: 30px;
        text-align: left;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
      }
      .color_title{
        color: #158869 !important;
      }
      .el-divider--horizontal{
        margin: 35px 0;
      }
    }
    .color_txt{
      .title_step{
        color: #134475 !important;
      }
      .banner_step{
        color: #134475 !important;
      }
    }
  }
  .step_right{
    width: 253px;
    min-height: 510px;
    // height: 530px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 20px 17px 20px 17px;
    .el-collapse{
      border: none;
    }
    .el-collapse-item__header{
      border: none;
      font-size: 14px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
      line-height: 16px;
    }
    .el-collapse-item__header.is-active{
      color: #158869 !important;
    }
    .title_steps{
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
    }
    .step_btns{
      margin: 0 auto;
      margin-top: 20px;
      width: 200px;
      border: 1px solid #158869;
      font-size: 20px;
      font-family: ArialMT;
      color: #158869;
      line-height: 23px;
      text-align: center;
      padding: 10px 0;
      border-radius: 10px;
      cursor: pointer;
    }
    .banner_box{
      background: #F8F9FA;
      border-radius: 10px;
      padding: 20px;
      margin-top: 20px;
      .box_box{
          .box_tit{
            font-size: 14px;
            font-family: ArialMT;
            color: #1E1E1E;
            line-height: 16px;
          }
          .box_txt{
            margin-top: 8px;
            font-size: 14px;
            font-family: ArialMT;
            color: #41566B;
            line-height: 20px;
            word-wrap: break-word;
          }
      }
    }
  }
  .step_right_fix{
    width: 253px;
    height: 370px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 20px 17px 20px 17px;
    position: absolute;
    right: 0;
    .el-collapse{
      border: none;
    }
    .el-collapse-item__header{
      border: none;
      font-size: 14px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
      line-height: 16px;
    }
    .el-collapse-item__header.is-active{
      color: #158869 !important;
    }
    .title_steps{
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
    }
    .step_btns{
      margin: 0 auto;
      margin-top: 20px;
      width: 200px;
      border: 1px solid #158869;
      font-size: 20px;
      font-family: ArialMT;
      color: #158869;
      line-height: 23px;
      text-align: center;
      padding: 10px 0;
      border-radius: 10px;
      cursor: pointer;
    }
  }
}
.title_box{
  // display: flex;
  padding-bottom: 20px;
  div{
      font-size: 20px;
      font-family: ArialMT;
      color: #626262;
      line-height: 30px;
      span{
        font-size: 18px;
        font-family: ArialMT;
        font-weight: normal;
        color: #626262;
        line-height: 30px;
        margin-left: 10px;
      }
  }
}
.step_btn{
  margin: 0 auto;
  margin-top: 20px;
  width: 150px;
  border: 1px solid #158869;
  font-size: 20px;
  font-family: ArialMT;
  color: #158869;
  line-height: 23px;
  text-align: center;
  padding: 10px 0;
  border-radius: 10px;
  cursor: pointer;
}
.step_btns{
  margin: 0 auto;
  margin-top: 20px;
  border: 1px solid #158869;
  font-size: 20px;
  font-family: ArialMT;
  color: #158869;
  line-height: 23px;
  text-align: center;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
}
.btn_box_left{
  width: auto;
  max-width: 300px;
}
.btn_box_flex{
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

::v-deep .TokenizeCarbon>.one > .el-collapse-item:nth-of-type(-n+4) .el-icon-arrow-right:before {
    content: " ";
}

.Tokenize_title{
  font-size: 24px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1E1E1E;
  margin-bottom: 28px;
}
.Tokenize_title_item{
  font-size: 20px;
  font-family: ArialMT;
  color: #626262;
  margin: 10px 10px 10px 28px
}
.owners{
  font-size: 24px;
  font-family: ArialMT;
  color: #1E1E1E;
  line-height: 34px;
  color: #158869;
}
.nfdtTitle{
  font-size: 18px;
  margin-bottom: 20px;
}
.action{
  width: 125px;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  text-align: center;
  font-family: ArialMT;
  color: #158869;
  border-radius: 4px;
  border: 1px solid #158869;
  cursor: pointer;
}
.action_btn{
  margin: 0 auto;
  // width: 125px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  font-size: 16px;
  font-family: ArialMT;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.open_btn{
  border: 1px solid #158869;
  background-color: #ffffff;
  color: #158869;
}
.open_btn:hover{
  background-color: #158869;
  color: #ffffff;
}
.country_txt{
  color: #158869;
  cursor: pointer;
}
::v-deep .el-dialog{
  margin-top: 40vh !important;
  // height: 311px;
  border-radius: 30px;
  .el-dialog__title{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .el-divider--horizontal{
    margin-top: 0;
  }
  .dialog_box_title{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #21212B;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .dialog_title{
    padding-top: 10px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .dialog_title_txt{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
    line-height: 24px;
  }
  .dialog_titles{
    text-align: center;
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
  }
  .ipt_box{
    width: 460px;
    margin:0 auto
  }
  .dialog_flex{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    .textone{
      font-size: 16px;
      font-family: ArialMT;
      color: #21212B;
      line-height: 23px;
      text-align: left;
      font-weight: 600;
    }
    .texttwo{
      text-align: right;
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      // font-weight: 600;
      color: #626262;
      line-height: 26px;
    }
  }
  .el-icon-close:before{
    content: url('../../assets/img/guanbi.png');
  }
}
.listStep{
  width: 150px;
  height: 50px;
  background-color: #158869;
  display: flex;
  align-items: center;
  border-radius: 10px 10px;
  color: #fff;
  display: flex;
  div{
    width: 25px;
    margin-right:10px;
    margin-left: 10px;
  }
}
.documentupload{
  padding: 7px 3px;
  border: 1px solid #158869;
  color: #158869;
  font-size: 13px;
  border-radius: 10px 10px;
  margin-top:10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img{
    margin-right:3px;
  }
}
.request_btn{
  line-height: 1;
  width: 120px;
  padding: 5px 2px;
  border-radius: 5px;
  background-color: #7CC0D3;
  color: #ffffff;
  font-size: 12px;
  margin: 5px auto;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
}
.btn_green{
  background-color: #548235;
}
.btn_orage{
  background-color: #c55a11;
}
.title_TEXT{
  height: 200px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-family: ArialMT;
  color: #626262;
  line-height: 30px;
}
.top_box{
  position: relative;
  .ab_box{
    position: absolute;
    bottom: 0;
    right: 0;
    width: 463px;
    height: 300px;
    .bg_tu_box{
      width: 100%;
      height: 100%;
    }
  }
  .ab_box1{
    position: absolute;
    bottom: 200px;
    right: 0;
    width: 463px;
    height: 300px;
    .bg_tu_box{
      width: 100%;
      height: 100%;
    }
  }
}
.detial_box{
  padding: 20px 0 0 20px;
  .detail_txt{
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 40px;
  }
}
.tab5_img{
  div{
    text-align: center;
    margin: 0 auto;
  }
  
}
a{
  text-decoration: none;
}
.carbon_btn_box{
  padding: 0 40px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #158869;
  font-size: 14px;
  font-family: ArialMT;
  color: #158869;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.bg_btn_box{
  background: #158869;
  color: #FFFFFF;
}
.carbon_btn_box_box{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
.disabled_cabon{
  border-color: #D0D0D0 !important;
  background: #D0D0D0 !important;
  color: #FFFFFF !important;
  cursor:not-allowed;
  // pointer-events:none;
}
.disabled_cabon_border{
  border-color: #D0D0D0 !important;
  color: #D0D0D0 !important;
  cursor:not-allowed;
  // pointer-events:none;
}
.btn_box_mg_dia{
    margin: 40px auto 0 auto;
    width: 125px;
    height: 44px;
    background: #158869;
    border-radius: 4px;
    font-size: 14px;
    font-family: ArialMT;
    color: #FFFFFF;
    line-height: 44px;
    padding: 0 20px;
    text-align: center;
    cursor: pointer;
}
.top1{
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cf_title{
  font-size: 24px;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  color: #1E1E1E;
  margin-bottom: 19px;
}
.cf_h3{
  font-size: 20px;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  color: #626262;
  margin-bottom: 10px;
}
.cf_h4{
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
  line-height: 32px;
}
.report_wrap_w{
  display: flex;
  justify-content: space-around;
  .report{
    width: 229px;
    height: 304px;
  }
  .btn_wrap{
    width: 167px;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #158869;
    font-size: 14px;
    font-family: ArialMT;
    color: #158869;
    margin-top:25px;
    background: #F8F9FA;
  }
  .report_wrap{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}
.listStep_border{
  border: 1px solid #158869;
  color:#158869;
  background: transparent;
}
.verificationbtn{
  width: 124px;
  height: 44px;
  background: #158869;
  border-radius: 4px;
  color:#ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
.verificationbtn1{
  border: 1px solid #158869;
  color: #158869;
  background-color: transparent;
}
.agency{
  font-size: 20px;
  font-family: Arial-BoldMT, Arial;
  font-weight: bold;
  color: #1E1E1E;
  margin-right: 105px;
  padding: 10px 20px;
  cursor: pointer;
}
.agency:last-child{
  margin-right: 0;
}
.agencySel{
  border-bottom: 3px solid #158869;
  color: #158869;
}
::v-deep .cf_box{
  position: relative;
  .cf_ad{
    background: #FFFFFF;
    padding: 46px 47px;
    margin-top: 30px;
    .cf_ad_txt1{
      font-size: 24px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
      margin-bottom: 20px;
    }
    .cf_ad_txt2{
      font-size: 20px;
      font-family: ArialMT;
      color: #158869;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .s_txt{
    font-size: 24px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
  }
  .mg{
    margin-bottom: 35px;
  }
  .mgr{
    margin-bottom: 26px;
  }
  .fx_b{
    display: flex;
    justify-content: center;
  }
  .btn_w{
    width: 150px;
  }
  .sts_txt{
    margin-top: 12px;
    text-align: center;
    font-size: 14px;
    font-family: ArialMT;
    color: #8F8F8F;
  }
  .fen_box{
    display: flex;
    justify-content: center;
    align-items: center;
    .btn_mg{
      margin-top: 0;
      margin-left: 30px;
    }
  }
  .radio{
    .el-radio__input.is-checked+.el-radio__label{
      font-size: 20px;
      font-family: ArialMT;
      color: #626262;
    }
    .el-radio__label{
      font-size: 20px;
      font-family: ArialMT;
      color: #626262;
    }
    .el-radio__inner{
      width: 20px;
      height: 20px;
    }
    .el-radio__input.is-checked .el-radio__inner{
      border-color: #158869;
      background: #158869;
    }
    .el-radio__inner{
      border-color: #158869;
    }
  }
  .banner_chek{
    margin-top: 62px;
  }
  .menu{
    width: 100%;
    height: 72px;
    background: #F0F3F6;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .mn_t{
      width: 160px;
      height: 70px;
      font-size: 20px;
      line-height: 72px;
      text-align: center;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #1E1E1E;
      cursor: pointer;
    }
    .hv{
      border-bottom: 4px solid #158869;
      color: #158869;

    }

  }
}
.btn_mg{
  margin-top: 0;
}
::v-deep .chk_box{
      .el-checkbox__input.is-checked+.el-checkbox__label{
        color: #626262;
      }
      .el-checkbox__label{
        color: #626262;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            border-color: #158869;
            background: #158869;
      }
      .el-checkbox__inner{
        border-color: #158869;
      }
    }
  ::v-deep .verifiCation{
    .el-dialog--center .el-dialog__body{
      padding: 25px 38px 30px;
    }
    .el-radio-group{
      padding-bottom: 30px;
    }
    .mgr{
      margin: 26px 0;
    }
    .radio{
      .el-radio__input.is-checked+.el-radio__label{
        font-size: 20px;
        font-family: ArialMT;
        color: #626262;
      }
      .el-radio__label{
        font-size: 20px;
        font-family: ArialMT;
        color: #626262;
      }
      .el-radio__inner{
        width: 20px;
        height: 20px;
      }
      .el-radio__input.is-checked .el-radio__inner{
        border-color: #158869;
        background: #158869;
      }
      .el-radio__inner{
        border-color: #158869;
      }
    }
  }
  .onSite{
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    margin: 20px 0;
    text-align: center;
  }
  ::v-deep .datePicker{
    margin-top: 30px;
    .el-date-editor.el-input{
      width: 100% !important;

    }
  }
  ::v-deep .el-button.is-disabled{
    width: 124px;
    height: 44px;
    background-color: #D0D0D0;
  }
  .s_h3{
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
  }
</style>
<style lang="scss">
.dropdown_header .el-dropdown-menu__item:hover{
  background: #F4FAF9;
  color: #158869;
}
.dropdown_header .el-dropdown-menu__item{
  font-size: 16px;
  font-family: ArialMT;
  color: #626262;
}

</style>
